const _i = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'%20?%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20width='16'%20height='17'%3e%3cpath%20fill='none'%20stroke='%2335AC5F'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'%20transform='translate(3.51246%203.81074)'%20d='M9%200C9%200%207.1231384%202.9768615%203.3694148%208.930584L0%206.5774164'%20fill-rule='evenodd'/%3e%3c/svg%3e", bi = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20width='16px'%20height='16px'%20viewBox='0%200%2016%2016'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cg%20stroke='none'%20stroke-width='1'%20fill='none'%20fill-rule='evenodd'%20stroke-linecap='round'%20stroke-linejoin='round'%3e%3cpath%20d='M12.5124603,3.81074193%20C12.5124603,3.81074193%2010.6355985,6.78760341%206.88187495,12.7413264%20L3.51246026,10.3881582'%20stroke='%230A75BD'%20stroke-width='1.5'%3e%3c/path%3e%3c/g%3e%3c/svg%3e";
var Be = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Xr(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Pt = {}, xt = {}, or;
function Ti() {
  return or || (or = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function() {
        return T;
      }
    });
    function r(e, f) {
      return {
        handler: e,
        config: f
      };
    }
    r.withOptions = function(e, f = () => ({})) {
      const w = function(p) {
        return {
          __options: p,
          handler: e(p),
          config: f(p)
        };
      };
      return w.__isOptionsFunction = !0, w.__pluginFunction = e, w.__configFunction = f, w;
    };
    const T = r;
  }(xt)), xt;
}
var sr;
function yi() {
  return sr || (sr = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    const r = /* @__PURE__ */ T(Ti());
    function T(f) {
      return f && f.__esModule ? f : {
        default: f
      };
    }
    const e = r.default;
  }(Pt)), Pt;
}
var qt, ur;
function Jr() {
  if (ur) return qt;
  ur = 1;
  let t = yi();
  return qt = (t.__esModule ? t : { default: t }).default, qt;
}
var Ce = { exports: {} };
Ce.exports;
var lr;
function Si() {
  return lr || (lr = 1, function(t, r) {
    var T = 200, e = "__lodash_hash_undefined__", f = 800, w = 16, p = 9007199254740991, v = "[object Arguments]", n = "[object Array]", o = "[object AsyncFunction]", s = "[object Boolean]", u = "[object Date]", d = "[object Error]", O = "[object Function]", P = "[object GeneratorFunction]", a = "[object Map]", c = "[object Number]", m = "[object Null]", _ = "[object Object]", y = "[object Proxy]", I = "[object RegExp]", h = "[object Set]", x = "[object String]", F = "[object Undefined]", D = "[object WeakMap]", E = "[object ArrayBuffer]", k = "[object DataView]", $ = "[object Float32Array]", Y = "[object Float64Array]", ae = "[object Int8Array]", ne = "[object Int16Array]", oe = "[object Int32Array]", W = "[object Uint8Array]", ce = "[object Uint8ClampedArray]", ve = "[object Uint16Array]", Ee = "[object Uint32Array]", me = /[\\^$.*+?()[\]{}|]/g, B = /^\[object .+?Constructor\]$/, R = /^(?:0|[1-9]\d*)$/, q = {};
    q[$] = q[Y] = q[ae] = q[ne] = q[oe] = q[W] = q[ce] = q[ve] = q[Ee] = !0, q[v] = q[n] = q[E] = q[s] = q[k] = q[u] = q[d] = q[O] = q[a] = q[c] = q[_] = q[I] = q[h] = q[x] = q[D] = !1;
    var b = typeof Be == "object" && Be && Be.Object === Object && Be, A = typeof self == "object" && self && self.Object === Object && self, M = b || A || Function("return this")(), S = r && !r.nodeType && r, z = S && !0 && t && !t.nodeType && t, Q = z && z.exports === S, H = Q && b.process, N = function() {
      try {
        var i = z && z.require && z.require("util").types;
        return i || H && H.binding && H.binding("util");
      } catch {
      }
    }(), K = N && N.isTypedArray;
    function ie(i, l, g) {
      switch (g.length) {
        case 0:
          return i.call(l);
        case 1:
          return i.call(l, g[0]);
        case 2:
          return i.call(l, g[0], g[1]);
        case 3:
          return i.call(l, g[0], g[1], g[2]);
      }
      return i.apply(l, g);
    }
    function U(i, l) {
      for (var g = -1, C = Array(i); ++g < i; )
        C[g] = l(g);
      return C;
    }
    function ee(i) {
      return function(l) {
        return i(l);
      };
    }
    function _e(i, l) {
      return i == null ? void 0 : i[l];
    }
    function we(i, l) {
      return function(g) {
        return i(l(g));
      };
    }
    var fe = Array.prototype, se = Function.prototype, ue = Object.prototype, de = M["__core-js_shared__"], pe = se.toString, he = ue.hasOwnProperty, ke = function() {
      var i = /[^.]+$/.exec(de && de.keys && de.keys.IE_PROTO || "");
      return i ? "Symbol(src)_1." + i : "";
    }(), Se = ue.toString, vt = pe.call(Object), mt = RegExp(
      "^" + pe.call(he).replace(me, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), qe = Q ? M.Buffer : void 0, Me = M.Symbol, Ne = M.Uint8Array;
    qe && qe.allocUnsafe;
    var ze = we(Object.getPrototypeOf, Object), Yt = Object.create, gn = ue.propertyIsEnumerable, vn = fe.splice, Ie = Me ? Me.toStringTag : void 0, Ue = function() {
      try {
        var i = bt(Object, "defineProperty");
        return i({}, "", {}), i;
      } catch {
      }
    }(), mn = qe ? qe.isBuffer : void 0, Qt = Math.max, wn = Date.now, Vt = bt(M, "Map"), Le = bt(Object, "create"), _n = /* @__PURE__ */ function() {
      function i() {
      }
      return function(l) {
        if (!xe(l))
          return {};
        if (Yt)
          return Yt(l);
        i.prototype = l;
        var g = new i();
        return i.prototype = void 0, g;
      };
    }();
    function Pe(i) {
      var l = -1, g = i == null ? 0 : i.length;
      for (this.clear(); ++l < g; ) {
        var C = i[l];
        this.set(C[0], C[1]);
      }
    }
    function bn() {
      this.__data__ = Le ? Le(null) : {}, this.size = 0;
    }
    function Tn(i) {
      var l = this.has(i) && delete this.__data__[i];
      return this.size -= l ? 1 : 0, l;
    }
    function yn(i) {
      var l = this.__data__;
      if (Le) {
        var g = l[i];
        return g === e ? void 0 : g;
      }
      return he.call(l, i) ? l[i] : void 0;
    }
    function Sn(i) {
      var l = this.__data__;
      return Le ? l[i] !== void 0 : he.call(l, i);
    }
    function On(i, l) {
      var g = this.__data__;
      return this.size += this.has(i) ? 0 : 1, g[i] = Le && l === void 0 ? e : l, this;
    }
    Pe.prototype.clear = bn, Pe.prototype.delete = Tn, Pe.prototype.get = yn, Pe.prototype.has = Sn, Pe.prototype.set = On;
    function ye(i) {
      var l = -1, g = i == null ? 0 : i.length;
      for (this.clear(); ++l < g; ) {
        var C = i[l];
        this.set(C[0], C[1]);
      }
    }
    function En() {
      this.__data__ = [], this.size = 0;
    }
    function kn(i) {
      var l = this.__data__, g = We(l, i);
      if (g < 0)
        return !1;
      var C = l.length - 1;
      return g == C ? l.pop() : vn.call(l, g, 1), --this.size, !0;
    }
    function In(i) {
      var l = this.__data__, g = We(l, i);
      return g < 0 ? void 0 : l[g][1];
    }
    function Pn(i) {
      return We(this.__data__, i) > -1;
    }
    function xn(i, l) {
      var g = this.__data__, C = We(g, i);
      return C < 0 ? (++this.size, g.push([i, l])) : g[C][1] = l, this;
    }
    ye.prototype.clear = En, ye.prototype.delete = kn, ye.prototype.get = In, ye.prototype.has = Pn, ye.prototype.set = xn;
    function Ae(i) {
      var l = -1, g = i == null ? 0 : i.length;
      for (this.clear(); ++l < g; ) {
        var C = i[l];
        this.set(C[0], C[1]);
      }
    }
    function qn() {
      this.size = 0, this.__data__ = {
        hash: new Pe(),
        map: new (Vt || ye)(),
        string: new Pe()
      };
    }
    function An(i) {
      var l = He(this, i).delete(i);
      return this.size -= l ? 1 : 0, l;
    }
    function Dn(i) {
      return He(this, i).get(i);
    }
    function Bn(i) {
      return He(this, i).has(i);
    }
    function Ln(i, l) {
      var g = He(this, i), C = g.size;
      return g.set(i, l), this.size += g.size == C ? 0 : 1, this;
    }
    Ae.prototype.clear = qn, Ae.prototype.delete = An, Ae.prototype.get = Dn, Ae.prototype.has = Bn, Ae.prototype.set = Ln;
    function De(i) {
      var l = this.__data__ = new ye(i);
      this.size = l.size;
    }
    function Rn() {
      this.__data__ = new ye(), this.size = 0;
    }
    function Fn(i) {
      var l = this.__data__, g = l.delete(i);
      return this.size = l.size, g;
    }
    function Cn(i) {
      return this.__data__.get(i);
    }
    function Mn(i) {
      return this.__data__.has(i);
    }
    function Nn(i, l) {
      var g = this.__data__;
      if (g instanceof ye) {
        var C = g.__data__;
        if (!Vt || C.length < T - 1)
          return C.push([i, l]), this.size = ++g.size, this;
        g = this.__data__ = new Ae(C);
      }
      return g.set(i, l), this.size = g.size, this;
    }
    De.prototype.clear = Rn, De.prototype.delete = Fn, De.prototype.get = Cn, De.prototype.has = Mn, De.prototype.set = Nn;
    function zn(i, l) {
      var g = St(i), C = !g && yt(i), j = !g && !C && er(i), X = !g && !C && !j && rr(i), te = g || C || j || X, V = te ? U(i.length, String) : [], re = V.length;
      for (var be in i)
        te && // Safari 9 has enumerable `arguments.length` in strict mode.
        (be == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        j && (be == "offset" || be == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        X && (be == "buffer" || be == "byteLength" || be == "byteOffset") || // Skip index properties.
        Jt(be, re)) || V.push(be);
      return V;
    }
    function wt(i, l, g) {
      (g !== void 0 && !je(i[l], g) || g === void 0 && !(l in i)) && _t(i, l, g);
    }
    function Un(i, l, g) {
      var C = i[l];
      (!(he.call(i, l) && je(C, g)) || g === void 0 && !(l in i)) && _t(i, l, g);
    }
    function We(i, l) {
      for (var g = i.length; g--; )
        if (je(i[g][0], l))
          return g;
      return -1;
    }
    function _t(i, l, g) {
      l == "__proto__" && Ue ? Ue(i, l, {
        configurable: !0,
        enumerable: !0,
        value: g,
        writable: !0
      }) : i[l] = g;
    }
    var Wn = ti();
    function $e(i) {
      return i == null ? i === void 0 ? F : m : Ie && Ie in Object(i) ? ri(i) : ui(i);
    }
    function Kt(i) {
      return Re(i) && $e(i) == v;
    }
    function $n(i) {
      if (!xe(i) || oi(i))
        return !1;
      var l = Et(i) ? mt : B;
      return l.test(di(i));
    }
    function Hn(i) {
      return Re(i) && tr(i.length) && !!q[$e(i)];
    }
    function jn(i) {
      if (!xe(i))
        return si(i);
      var l = Zt(i), g = [];
      for (var C in i)
        C == "constructor" && (l || !he.call(i, C)) || g.push(C);
      return g;
    }
    function Xt(i, l, g, C, j) {
      i !== l && Wn(l, function(X, te) {
        if (j || (j = new De()), xe(X))
          Gn(i, l, te, g, Xt, C, j);
        else {
          var V = C ? C(Tt(i, te), X, te + "", i, l, j) : void 0;
          V === void 0 && (V = X), wt(i, te, V);
        }
      }, nr);
    }
    function Gn(i, l, g, C, j, X, te) {
      var V = Tt(i, g), re = Tt(l, g), be = te.get(re);
      if (be) {
        wt(i, g, be);
        return;
      }
      var ge = X ? X(V, re, g + "", i, l, te) : void 0, Fe = ge === void 0;
      if (Fe) {
        var kt = St(re), It = !kt && er(re), ar = !kt && !It && rr(re);
        ge = re, kt || It || ar ? St(V) ? ge = V : pi(V) ? ge = Jn(V) : It ? (Fe = !1, ge = Vn(re)) : ar ? (Fe = !1, ge = Xn(re)) : ge = [] : hi(re) || yt(re) ? (ge = V, yt(V) ? ge = gi(V) : (!xe(V) || Et(V)) && (ge = ni(re))) : Fe = !1;
      }
      Fe && (te.set(re, ge), j(ge, re, C, X, te), te.delete(re)), wt(i, g, ge);
    }
    function Yn(i, l) {
      return ci(li(i, l, ir), i + "");
    }
    var Qn = Ue ? function(i, l) {
      return Ue(i, "toString", {
        configurable: !0,
        enumerable: !1,
        value: mi(l),
        writable: !0
      });
    } : ir;
    function Vn(i, l) {
      return i.slice();
    }
    function Kn(i) {
      var l = new i.constructor(i.byteLength);
      return new Ne(l).set(new Ne(i)), l;
    }
    function Xn(i, l) {
      var g = Kn(i.buffer);
      return new i.constructor(g, i.byteOffset, i.length);
    }
    function Jn(i, l) {
      var g = -1, C = i.length;
      for (l || (l = Array(C)); ++g < C; )
        l[g] = i[g];
      return l;
    }
    function Zn(i, l, g, C) {
      var j = !g;
      g || (g = {});
      for (var X = -1, te = l.length; ++X < te; ) {
        var V = l[X], re = void 0;
        re === void 0 && (re = i[V]), j ? _t(g, V, re) : Un(g, V, re);
      }
      return g;
    }
    function ei(i) {
      return Yn(function(l, g) {
        var C = -1, j = g.length, X = j > 1 ? g[j - 1] : void 0, te = j > 2 ? g[2] : void 0;
        for (X = i.length > 3 && typeof X == "function" ? (j--, X) : void 0, te && ii(g[0], g[1], te) && (X = j < 3 ? void 0 : X, j = 1), l = Object(l); ++C < j; ) {
          var V = g[C];
          V && i(l, V, C, X);
        }
        return l;
      });
    }
    function ti(i) {
      return function(l, g, C) {
        for (var j = -1, X = Object(l), te = C(l), V = te.length; V--; ) {
          var re = te[++j];
          if (g(X[re], re, X) === !1)
            break;
        }
        return l;
      };
    }
    function He(i, l) {
      var g = i.__data__;
      return ai(l) ? g[typeof l == "string" ? "string" : "hash"] : g.map;
    }
    function bt(i, l) {
      var g = _e(i, l);
      return $n(g) ? g : void 0;
    }
    function ri(i) {
      var l = he.call(i, Ie), g = i[Ie];
      try {
        i[Ie] = void 0;
        var C = !0;
      } catch {
      }
      var j = Se.call(i);
      return C && (l ? i[Ie] = g : delete i[Ie]), j;
    }
    function ni(i) {
      return typeof i.constructor == "function" && !Zt(i) ? _n(ze(i)) : {};
    }
    function Jt(i, l) {
      var g = typeof i;
      return l = l ?? p, !!l && (g == "number" || g != "symbol" && R.test(i)) && i > -1 && i % 1 == 0 && i < l;
    }
    function ii(i, l, g) {
      if (!xe(g))
        return !1;
      var C = typeof l;
      return (C == "number" ? Ot(g) && Jt(l, g.length) : C == "string" && l in g) ? je(g[l], i) : !1;
    }
    function ai(i) {
      var l = typeof i;
      return l == "string" || l == "number" || l == "symbol" || l == "boolean" ? i !== "__proto__" : i === null;
    }
    function oi(i) {
      return !!ke && ke in i;
    }
    function Zt(i) {
      var l = i && i.constructor, g = typeof l == "function" && l.prototype || ue;
      return i === g;
    }
    function si(i) {
      var l = [];
      if (i != null)
        for (var g in Object(i))
          l.push(g);
      return l;
    }
    function ui(i) {
      return Se.call(i);
    }
    function li(i, l, g) {
      return l = Qt(l === void 0 ? i.length - 1 : l, 0), function() {
        for (var C = arguments, j = -1, X = Qt(C.length - l, 0), te = Array(X); ++j < X; )
          te[j] = C[l + j];
        j = -1;
        for (var V = Array(l + 1); ++j < l; )
          V[j] = C[j];
        return V[l] = g(te), ie(i, this, V);
      };
    }
    function Tt(i, l) {
      if (!(l === "constructor" && typeof i[l] == "function") && l != "__proto__")
        return i[l];
    }
    var ci = fi(Qn);
    function fi(i) {
      var l = 0, g = 0;
      return function() {
        var C = wn(), j = w - (C - g);
        if (g = C, j > 0) {
          if (++l >= f)
            return arguments[0];
        } else
          l = 0;
        return i.apply(void 0, arguments);
      };
    }
    function di(i) {
      if (i != null) {
        try {
          return pe.call(i);
        } catch {
        }
        try {
          return i + "";
        } catch {
        }
      }
      return "";
    }
    function je(i, l) {
      return i === l || i !== i && l !== l;
    }
    var yt = Kt(/* @__PURE__ */ function() {
      return arguments;
    }()) ? Kt : function(i) {
      return Re(i) && he.call(i, "callee") && !gn.call(i, "callee");
    }, St = Array.isArray;
    function Ot(i) {
      return i != null && tr(i.length) && !Et(i);
    }
    function pi(i) {
      return Re(i) && Ot(i);
    }
    var er = mn || wi;
    function Et(i) {
      if (!xe(i))
        return !1;
      var l = $e(i);
      return l == O || l == P || l == o || l == y;
    }
    function tr(i) {
      return typeof i == "number" && i > -1 && i % 1 == 0 && i <= p;
    }
    function xe(i) {
      var l = typeof i;
      return i != null && (l == "object" || l == "function");
    }
    function Re(i) {
      return i != null && typeof i == "object";
    }
    function hi(i) {
      if (!Re(i) || $e(i) != _)
        return !1;
      var l = ze(i);
      if (l === null)
        return !0;
      var g = he.call(l, "constructor") && l.constructor;
      return typeof g == "function" && g instanceof g && pe.call(g) == vt;
    }
    var rr = K ? ee(K) : Hn;
    function gi(i) {
      return Zn(i, nr(i));
    }
    function nr(i) {
      return Ot(i) ? zn(i) : jn(i);
    }
    var vi = ei(function(i, l, g) {
      Xt(i, l, g);
    });
    function mi(i) {
      return function() {
        return i;
      };
    }
    function ir(i) {
      return i;
    }
    function wi() {
      return !1;
    }
    t.exports = vi;
  }(Ce, Ce.exports)), Ce.exports;
}
var At, cr;
function Oi() {
  if (cr) return At;
  cr = 1;
  function t() {
    if (!arguments.length)
      return [];
    var T = arguments[0];
    return r(T) ? T : [T];
  }
  var r = Array.isArray;
  return At = t, At;
}
var Dt = {}, Bt = {}, Ge = { exports: {} }, fr;
function Ei() {
  if (fr) return Ge.exports;
  fr = 1;
  var t = String, r = function() {
    return { isColorSupported: !1, reset: t, bold: t, dim: t, italic: t, underline: t, inverse: t, hidden: t, strikethrough: t, black: t, red: t, green: t, yellow: t, blue: t, magenta: t, cyan: t, white: t, gray: t, bgBlack: t, bgRed: t, bgGreen: t, bgYellow: t, bgBlue: t, bgMagenta: t, bgCyan: t, bgWhite: t, blackBright: t, redBright: t, greenBright: t, yellowBright: t, blueBright: t, magentaBright: t, cyanBright: t, whiteBright: t, bgBlackBright: t, bgRedBright: t, bgGreenBright: t, bgYellowBright: t, bgBlueBright: t, bgMagentaBright: t, bgCyanBright: t, bgWhiteBright: t };
  };
  return Ge.exports = r(), Ge.exports.createColors = r, Ge.exports;
}
var dr;
function ki() {
  return dr || (dr = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function r(n, o) {
      for (var s in o) Object.defineProperty(n, s, {
        enumerable: !0,
        get: o[s]
      });
    }
    r(t, {
      dim: function() {
        return p;
      },
      default: function() {
        return v;
      }
    });
    const T = /* @__PURE__ */ e(/* @__PURE__ */ Ei());
    function e(n) {
      return n && n.__esModule ? n : {
        default: n
      };
    }
    let f = /* @__PURE__ */ new Set();
    function w(n, o, s) {
      typeof process < "u" && process.env.JEST_WORKER_ID || s && f.has(s) || (s && f.add(s), console.warn(""), o.forEach((u) => console.warn(n, "-", u)));
    }
    function p(n) {
      return T.default.dim(n);
    }
    const v = {
      info(n, o) {
        w(T.default.bold(T.default.cyan("info")), ...Array.isArray(n) ? [
          n
        ] : [
          o,
          n
        ]);
      },
      warn(n, o) {
        w(T.default.bold(T.default.yellow("warn")), ...Array.isArray(n) ? [
          n
        ] : [
          o,
          n
        ]);
      },
      risk(n, o) {
        w(T.default.bold(T.default.magenta("risk")), ...Array.isArray(n) ? [
          n
        ] : [
          o,
          n
        ]);
      }
    };
  }(Bt)), Bt;
}
var pr;
function Ii() {
  return pr || (pr = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function() {
        return f;
      }
    });
    const r = /* @__PURE__ */ T(ki());
    function T(w) {
      return w && w.__esModule ? w : {
        default: w
      };
    }
    function e({ version: w, from: p, to: v }) {
      r.default.warn(`${p}-color-renamed`, [
        `As of Tailwind CSS ${w}, \`${p}\` has been renamed to \`${v}\`.`,
        "Update your configuration file to silence this warning."
      ]);
    }
    const f = {
      inherit: "inherit",
      current: "currentColor",
      transparent: "transparent",
      black: "#000",
      white: "#fff",
      slate: {
        50: "#f8fafc",
        100: "#f1f5f9",
        200: "#e2e8f0",
        300: "#cbd5e1",
        400: "#94a3b8",
        500: "#64748b",
        600: "#475569",
        700: "#334155",
        800: "#1e293b",
        900: "#0f172a",
        950: "#020617"
      },
      gray: {
        50: "#f9fafb",
        100: "#f3f4f6",
        200: "#e5e7eb",
        300: "#d1d5db",
        400: "#9ca3af",
        500: "#6b7280",
        600: "#4b5563",
        700: "#374151",
        800: "#1f2937",
        900: "#111827",
        950: "#030712"
      },
      zinc: {
        50: "#fafafa",
        100: "#f4f4f5",
        200: "#e4e4e7",
        300: "#d4d4d8",
        400: "#a1a1aa",
        500: "#71717a",
        600: "#52525b",
        700: "#3f3f46",
        800: "#27272a",
        900: "#18181b",
        950: "#09090b"
      },
      neutral: {
        50: "#fafafa",
        100: "#f5f5f5",
        200: "#e5e5e5",
        300: "#d4d4d4",
        400: "#a3a3a3",
        500: "#737373",
        600: "#525252",
        700: "#404040",
        800: "#262626",
        900: "#171717",
        950: "#0a0a0a"
      },
      stone: {
        50: "#fafaf9",
        100: "#f5f5f4",
        200: "#e7e5e4",
        300: "#d6d3d1",
        400: "#a8a29e",
        500: "#78716c",
        600: "#57534e",
        700: "#44403c",
        800: "#292524",
        900: "#1c1917",
        950: "#0c0a09"
      },
      red: {
        50: "#fef2f2",
        100: "#fee2e2",
        200: "#fecaca",
        300: "#fca5a5",
        400: "#f87171",
        500: "#ef4444",
        600: "#dc2626",
        700: "#b91c1c",
        800: "#991b1b",
        900: "#7f1d1d",
        950: "#450a0a"
      },
      orange: {
        50: "#fff7ed",
        100: "#ffedd5",
        200: "#fed7aa",
        300: "#fdba74",
        400: "#fb923c",
        500: "#f97316",
        600: "#ea580c",
        700: "#c2410c",
        800: "#9a3412",
        900: "#7c2d12",
        950: "#431407"
      },
      amber: {
        50: "#fffbeb",
        100: "#fef3c7",
        200: "#fde68a",
        300: "#fcd34d",
        400: "#fbbf24",
        500: "#f59e0b",
        600: "#d97706",
        700: "#b45309",
        800: "#92400e",
        900: "#78350f",
        950: "#451a03"
      },
      yellow: {
        50: "#fefce8",
        100: "#fef9c3",
        200: "#fef08a",
        300: "#fde047",
        400: "#facc15",
        500: "#eab308",
        600: "#ca8a04",
        700: "#a16207",
        800: "#854d0e",
        900: "#713f12",
        950: "#422006"
      },
      lime: {
        50: "#f7fee7",
        100: "#ecfccb",
        200: "#d9f99d",
        300: "#bef264",
        400: "#a3e635",
        500: "#84cc16",
        600: "#65a30d",
        700: "#4d7c0f",
        800: "#3f6212",
        900: "#365314",
        950: "#1a2e05"
      },
      green: {
        50: "#f0fdf4",
        100: "#dcfce7",
        200: "#bbf7d0",
        300: "#86efac",
        400: "#4ade80",
        500: "#22c55e",
        600: "#16a34a",
        700: "#15803d",
        800: "#166534",
        900: "#14532d",
        950: "#052e16"
      },
      emerald: {
        50: "#ecfdf5",
        100: "#d1fae5",
        200: "#a7f3d0",
        300: "#6ee7b7",
        400: "#34d399",
        500: "#10b981",
        600: "#059669",
        700: "#047857",
        800: "#065f46",
        900: "#064e3b",
        950: "#022c22"
      },
      teal: {
        50: "#f0fdfa",
        100: "#ccfbf1",
        200: "#99f6e4",
        300: "#5eead4",
        400: "#2dd4bf",
        500: "#14b8a6",
        600: "#0d9488",
        700: "#0f766e",
        800: "#115e59",
        900: "#134e4a",
        950: "#042f2e"
      },
      cyan: {
        50: "#ecfeff",
        100: "#cffafe",
        200: "#a5f3fc",
        300: "#67e8f9",
        400: "#22d3ee",
        500: "#06b6d4",
        600: "#0891b2",
        700: "#0e7490",
        800: "#155e75",
        900: "#164e63",
        950: "#083344"
      },
      sky: {
        50: "#f0f9ff",
        100: "#e0f2fe",
        200: "#bae6fd",
        300: "#7dd3fc",
        400: "#38bdf8",
        500: "#0ea5e9",
        600: "#0284c7",
        700: "#0369a1",
        800: "#075985",
        900: "#0c4a6e",
        950: "#082f49"
      },
      blue: {
        50: "#eff6ff",
        100: "#dbeafe",
        200: "#bfdbfe",
        300: "#93c5fd",
        400: "#60a5fa",
        500: "#3b82f6",
        600: "#2563eb",
        700: "#1d4ed8",
        800: "#1e40af",
        900: "#1e3a8a",
        950: "#172554"
      },
      indigo: {
        50: "#eef2ff",
        100: "#e0e7ff",
        200: "#c7d2fe",
        300: "#a5b4fc",
        400: "#818cf8",
        500: "#6366f1",
        600: "#4f46e5",
        700: "#4338ca",
        800: "#3730a3",
        900: "#312e81",
        950: "#1e1b4b"
      },
      violet: {
        50: "#f5f3ff",
        100: "#ede9fe",
        200: "#ddd6fe",
        300: "#c4b5fd",
        400: "#a78bfa",
        500: "#8b5cf6",
        600: "#7c3aed",
        700: "#6d28d9",
        800: "#5b21b6",
        900: "#4c1d95",
        950: "#2e1065"
      },
      purple: {
        50: "#faf5ff",
        100: "#f3e8ff",
        200: "#e9d5ff",
        300: "#d8b4fe",
        400: "#c084fc",
        500: "#a855f7",
        600: "#9333ea",
        700: "#7e22ce",
        800: "#6b21a8",
        900: "#581c87",
        950: "#3b0764"
      },
      fuchsia: {
        50: "#fdf4ff",
        100: "#fae8ff",
        200: "#f5d0fe",
        300: "#f0abfc",
        400: "#e879f9",
        500: "#d946ef",
        600: "#c026d3",
        700: "#a21caf",
        800: "#86198f",
        900: "#701a75",
        950: "#4a044e"
      },
      pink: {
        50: "#fdf2f8",
        100: "#fce7f3",
        200: "#fbcfe8",
        300: "#f9a8d4",
        400: "#f472b6",
        500: "#ec4899",
        600: "#db2777",
        700: "#be185d",
        800: "#9d174d",
        900: "#831843",
        950: "#500724"
      },
      rose: {
        50: "#fff1f2",
        100: "#ffe4e6",
        200: "#fecdd3",
        300: "#fda4af",
        400: "#fb7185",
        500: "#f43f5e",
        600: "#e11d48",
        700: "#be123c",
        800: "#9f1239",
        900: "#881337",
        950: "#4c0519"
      },
      get lightBlue() {
        return e({
          version: "v2.2",
          from: "lightBlue",
          to: "sky"
        }), this.sky;
      },
      get warmGray() {
        return e({
          version: "v3.0",
          from: "warmGray",
          to: "stone"
        }), this.stone;
      },
      get trueGray() {
        return e({
          version: "v3.0",
          from: "trueGray",
          to: "neutral"
        }), this.neutral;
      },
      get coolGray() {
        return e({
          version: "v3.0",
          from: "coolGray",
          to: "gray"
        }), this.gray;
      },
      get blueGray() {
        return e({
          version: "v3.0",
          from: "blueGray",
          to: "slate"
        }), this.slate;
      }
    };
  }(Dt)), Dt;
}
var Lt, hr;
function Pi() {
  if (hr) return Lt;
  hr = 1;
  let t = Ii();
  return Lt = (t.__esModule ? t : { default: t }).default, Lt;
}
var Rt, gr;
function xi() {
  if (gr) return Rt;
  gr = 1;
  const t = Pi(), r = (p) => p.toFixed(7).replace(/(\.[0-9]+?)0+$/, "$1").replace(/\.0$/, ""), T = (p) => `${r(p / 16)}rem`, e = (p, v) => `${r(p / v)}em`, f = (p) => {
    p = p.replace("#", ""), p = p.length === 3 ? p.replace(/./g, "$&$&") : p;
    const v = parseInt(p.substring(0, 2), 16), n = parseInt(p.substring(2, 4), 16), o = parseInt(p.substring(4, 6), 16);
    return `${v} ${n} ${o}`;
  };
  let w = {
    sm: {
      css: [
        {
          fontSize: T(14),
          lineHeight: r(24 / 14),
          p: {
            marginTop: e(16, 14),
            marginBottom: e(16, 14)
          },
          '[class~="lead"]': {
            fontSize: e(18, 14),
            lineHeight: r(28 / 18),
            marginTop: e(16, 18),
            marginBottom: e(16, 18)
          },
          blockquote: {
            marginTop: e(24, 18),
            marginBottom: e(24, 18),
            paddingInlineStart: e(20, 18)
          },
          h1: {
            fontSize: e(30, 14),
            marginTop: "0",
            marginBottom: e(24, 30),
            lineHeight: r(36 / 30)
          },
          h2: {
            fontSize: e(20, 14),
            marginTop: e(32, 20),
            marginBottom: e(16, 20),
            lineHeight: r(28 / 20)
          },
          h3: {
            fontSize: e(18, 14),
            marginTop: e(28, 18),
            marginBottom: e(8, 18),
            lineHeight: r(28 / 18)
          },
          h4: {
            marginTop: e(20, 14),
            marginBottom: e(8, 14),
            lineHeight: r(20 / 14)
          },
          img: {
            marginTop: e(24, 14),
            marginBottom: e(24, 14)
          },
          picture: {
            marginTop: e(24, 14),
            marginBottom: e(24, 14)
          },
          "picture > img": {
            marginTop: "0",
            marginBottom: "0"
          },
          video: {
            marginTop: e(24, 14),
            marginBottom: e(24, 14)
          },
          kbd: {
            fontSize: e(12, 14),
            borderRadius: T(5),
            paddingTop: e(2, 14),
            paddingInlineEnd: e(5, 14),
            paddingBottom: e(2, 14),
            paddingInlineStart: e(5, 14)
          },
          code: {
            fontSize: e(12, 14)
          },
          "h2 code": {
            fontSize: e(18, 20)
          },
          "h3 code": {
            fontSize: e(16, 18)
          },
          pre: {
            fontSize: e(12, 14),
            lineHeight: r(20 / 12),
            marginTop: e(20, 12),
            marginBottom: e(20, 12),
            borderRadius: T(4),
            paddingTop: e(8, 12),
            paddingInlineEnd: e(12, 12),
            paddingBottom: e(8, 12),
            paddingInlineStart: e(12, 12)
          },
          ol: {
            marginTop: e(16, 14),
            marginBottom: e(16, 14),
            paddingInlineStart: e(22, 14)
          },
          ul: {
            marginTop: e(16, 14),
            marginBottom: e(16, 14),
            paddingInlineStart: e(22, 14)
          },
          li: {
            marginTop: e(4, 14),
            marginBottom: e(4, 14)
          },
          "ol > li": {
            paddingInlineStart: e(6, 14)
          },
          "ul > li": {
            paddingInlineStart: e(6, 14)
          },
          "> ul > li p": {
            marginTop: e(8, 14),
            marginBottom: e(8, 14)
          },
          "> ul > li > p:first-child": {
            marginTop: e(16, 14)
          },
          "> ul > li > p:last-child": {
            marginBottom: e(16, 14)
          },
          "> ol > li > p:first-child": {
            marginTop: e(16, 14)
          },
          "> ol > li > p:last-child": {
            marginBottom: e(16, 14)
          },
          "ul ul, ul ol, ol ul, ol ol": {
            marginTop: e(8, 14),
            marginBottom: e(8, 14)
          },
          dl: {
            marginTop: e(16, 14),
            marginBottom: e(16, 14)
          },
          dt: {
            marginTop: e(16, 14)
          },
          dd: {
            marginTop: e(4, 14),
            paddingInlineStart: e(22, 14)
          },
          hr: {
            marginTop: e(40, 14),
            marginBottom: e(40, 14)
          },
          "hr + *": {
            marginTop: "0"
          },
          "h2 + *": {
            marginTop: "0"
          },
          "h3 + *": {
            marginTop: "0"
          },
          "h4 + *": {
            marginTop: "0"
          },
          table: {
            fontSize: e(12, 14),
            lineHeight: r(18 / 12)
          },
          "thead th": {
            paddingInlineEnd: e(12, 12),
            paddingBottom: e(8, 12),
            paddingInlineStart: e(12, 12)
          },
          "thead th:first-child": {
            paddingInlineStart: "0"
          },
          "thead th:last-child": {
            paddingInlineEnd: "0"
          },
          "tbody td, tfoot td": {
            paddingTop: e(8, 12),
            paddingInlineEnd: e(12, 12),
            paddingBottom: e(8, 12),
            paddingInlineStart: e(12, 12)
          },
          "tbody td:first-child, tfoot td:first-child": {
            paddingInlineStart: "0"
          },
          "tbody td:last-child, tfoot td:last-child": {
            paddingInlineEnd: "0"
          },
          figure: {
            marginTop: e(24, 14),
            marginBottom: e(24, 14)
          },
          "figure > *": {
            marginTop: "0",
            marginBottom: "0"
          },
          figcaption: {
            fontSize: e(12, 14),
            lineHeight: r(16 / 12),
            marginTop: e(8, 12)
          }
        },
        {
          "> :first-child": {
            marginTop: "0"
          },
          "> :last-child": {
            marginBottom: "0"
          }
        }
      ]
    },
    base: {
      css: [
        {
          fontSize: T(16),
          lineHeight: r(28 / 16),
          p: {
            marginTop: e(20, 16),
            marginBottom: e(20, 16)
          },
          '[class~="lead"]': {
            fontSize: e(20, 16),
            lineHeight: r(32 / 20),
            marginTop: e(24, 20),
            marginBottom: e(24, 20)
          },
          blockquote: {
            marginTop: e(32, 20),
            marginBottom: e(32, 20),
            paddingInlineStart: e(20, 20)
          },
          h1: {
            fontSize: e(36, 16),
            marginTop: "0",
            marginBottom: e(32, 36),
            lineHeight: r(40 / 36)
          },
          h2: {
            fontSize: e(24, 16),
            marginTop: e(48, 24),
            marginBottom: e(24, 24),
            lineHeight: r(32 / 24)
          },
          h3: {
            fontSize: e(20, 16),
            marginTop: e(32, 20),
            marginBottom: e(12, 20),
            lineHeight: r(32 / 20)
          },
          h4: {
            marginTop: e(24, 16),
            marginBottom: e(8, 16),
            lineHeight: r(24 / 16)
          },
          img: {
            marginTop: e(32, 16),
            marginBottom: e(32, 16)
          },
          picture: {
            marginTop: e(32, 16),
            marginBottom: e(32, 16)
          },
          "picture > img": {
            marginTop: "0",
            marginBottom: "0"
          },
          video: {
            marginTop: e(32, 16),
            marginBottom: e(32, 16)
          },
          kbd: {
            fontSize: e(14, 16),
            borderRadius: T(5),
            paddingTop: e(3, 16),
            paddingInlineEnd: e(6, 16),
            paddingBottom: e(3, 16),
            paddingInlineStart: e(6, 16)
          },
          code: {
            fontSize: e(14, 16)
          },
          "h2 code": {
            fontSize: e(21, 24)
          },
          "h3 code": {
            fontSize: e(18, 20)
          },
          pre: {
            fontSize: e(14, 16),
            lineHeight: r(24 / 14),
            marginTop: e(24, 14),
            marginBottom: e(24, 14),
            borderRadius: T(6),
            paddingTop: e(12, 14),
            paddingInlineEnd: e(16, 14),
            paddingBottom: e(12, 14),
            paddingInlineStart: e(16, 14)
          },
          ol: {
            marginTop: e(20, 16),
            marginBottom: e(20, 16),
            paddingInlineStart: e(26, 16)
          },
          ul: {
            marginTop: e(20, 16),
            marginBottom: e(20, 16),
            paddingInlineStart: e(26, 16)
          },
          li: {
            marginTop: e(8, 16),
            marginBottom: e(8, 16)
          },
          "ol > li": {
            paddingInlineStart: e(6, 16)
          },
          "ul > li": {
            paddingInlineStart: e(6, 16)
          },
          "> ul > li p": {
            marginTop: e(12, 16),
            marginBottom: e(12, 16)
          },
          "> ul > li > p:first-child": {
            marginTop: e(20, 16)
          },
          "> ul > li > p:last-child": {
            marginBottom: e(20, 16)
          },
          "> ol > li > p:first-child": {
            marginTop: e(20, 16)
          },
          "> ol > li > p:last-child": {
            marginBottom: e(20, 16)
          },
          "ul ul, ul ol, ol ul, ol ol": {
            marginTop: e(12, 16),
            marginBottom: e(12, 16)
          },
          dl: {
            marginTop: e(20, 16),
            marginBottom: e(20, 16)
          },
          dt: {
            marginTop: e(20, 16)
          },
          dd: {
            marginTop: e(8, 16),
            paddingInlineStart: e(26, 16)
          },
          hr: {
            marginTop: e(48, 16),
            marginBottom: e(48, 16)
          },
          "hr + *": {
            marginTop: "0"
          },
          "h2 + *": {
            marginTop: "0"
          },
          "h3 + *": {
            marginTop: "0"
          },
          "h4 + *": {
            marginTop: "0"
          },
          table: {
            fontSize: e(14, 16),
            lineHeight: r(24 / 14)
          },
          "thead th": {
            paddingInlineEnd: e(8, 14),
            paddingBottom: e(8, 14),
            paddingInlineStart: e(8, 14)
          },
          "thead th:first-child": {
            paddingInlineStart: "0"
          },
          "thead th:last-child": {
            paddingInlineEnd: "0"
          },
          "tbody td, tfoot td": {
            paddingTop: e(8, 14),
            paddingInlineEnd: e(8, 14),
            paddingBottom: e(8, 14),
            paddingInlineStart: e(8, 14)
          },
          "tbody td:first-child, tfoot td:first-child": {
            paddingInlineStart: "0"
          },
          "tbody td:last-child, tfoot td:last-child": {
            paddingInlineEnd: "0"
          },
          figure: {
            marginTop: e(32, 16),
            marginBottom: e(32, 16)
          },
          "figure > *": {
            marginTop: "0",
            marginBottom: "0"
          },
          figcaption: {
            fontSize: e(14, 16),
            lineHeight: r(20 / 14),
            marginTop: e(12, 14)
          }
        },
        {
          "> :first-child": {
            marginTop: "0"
          },
          "> :last-child": {
            marginBottom: "0"
          }
        }
      ]
    },
    lg: {
      css: [
        {
          fontSize: T(18),
          lineHeight: r(32 / 18),
          p: {
            marginTop: e(24, 18),
            marginBottom: e(24, 18)
          },
          '[class~="lead"]': {
            fontSize: e(22, 18),
            lineHeight: r(32 / 22),
            marginTop: e(24, 22),
            marginBottom: e(24, 22)
          },
          blockquote: {
            marginTop: e(40, 24),
            marginBottom: e(40, 24),
            paddingInlineStart: e(24, 24)
          },
          h1: {
            fontSize: e(48, 18),
            marginTop: "0",
            marginBottom: e(40, 48),
            lineHeight: r(48 / 48)
          },
          h2: {
            fontSize: e(30, 18),
            marginTop: e(56, 30),
            marginBottom: e(32, 30),
            lineHeight: r(40 / 30)
          },
          h3: {
            fontSize: e(24, 18),
            marginTop: e(40, 24),
            marginBottom: e(16, 24),
            lineHeight: r(36 / 24)
          },
          h4: {
            marginTop: e(32, 18),
            marginBottom: e(8, 18),
            lineHeight: r(28 / 18)
          },
          img: {
            marginTop: e(32, 18),
            marginBottom: e(32, 18)
          },
          picture: {
            marginTop: e(32, 18),
            marginBottom: e(32, 18)
          },
          "picture > img": {
            marginTop: "0",
            marginBottom: "0"
          },
          video: {
            marginTop: e(32, 18),
            marginBottom: e(32, 18)
          },
          kbd: {
            fontSize: e(16, 18),
            borderRadius: T(5),
            paddingTop: e(4, 18),
            paddingInlineEnd: e(8, 18),
            paddingBottom: e(4, 18),
            paddingInlineStart: e(8, 18)
          },
          code: {
            fontSize: e(16, 18)
          },
          "h2 code": {
            fontSize: e(26, 30)
          },
          "h3 code": {
            fontSize: e(21, 24)
          },
          pre: {
            fontSize: e(16, 18),
            lineHeight: r(28 / 16),
            marginTop: e(32, 16),
            marginBottom: e(32, 16),
            borderRadius: T(6),
            paddingTop: e(16, 16),
            paddingInlineEnd: e(24, 16),
            paddingBottom: e(16, 16),
            paddingInlineStart: e(24, 16)
          },
          ol: {
            marginTop: e(24, 18),
            marginBottom: e(24, 18),
            paddingInlineStart: e(28, 18)
          },
          ul: {
            marginTop: e(24, 18),
            marginBottom: e(24, 18),
            paddingInlineStart: e(28, 18)
          },
          li: {
            marginTop: e(12, 18),
            marginBottom: e(12, 18)
          },
          "ol > li": {
            paddingInlineStart: e(8, 18)
          },
          "ul > li": {
            paddingInlineStart: e(8, 18)
          },
          "> ul > li p": {
            marginTop: e(16, 18),
            marginBottom: e(16, 18)
          },
          "> ul > li > p:first-child": {
            marginTop: e(24, 18)
          },
          "> ul > li > p:last-child": {
            marginBottom: e(24, 18)
          },
          "> ol > li > p:first-child": {
            marginTop: e(24, 18)
          },
          "> ol > li > p:last-child": {
            marginBottom: e(24, 18)
          },
          "ul ul, ul ol, ol ul, ol ol": {
            marginTop: e(16, 18),
            marginBottom: e(16, 18)
          },
          dl: {
            marginTop: e(24, 18),
            marginBottom: e(24, 18)
          },
          dt: {
            marginTop: e(24, 18)
          },
          dd: {
            marginTop: e(12, 18),
            paddingInlineStart: e(28, 18)
          },
          hr: {
            marginTop: e(56, 18),
            marginBottom: e(56, 18)
          },
          "hr + *": {
            marginTop: "0"
          },
          "h2 + *": {
            marginTop: "0"
          },
          "h3 + *": {
            marginTop: "0"
          },
          "h4 + *": {
            marginTop: "0"
          },
          table: {
            fontSize: e(16, 18),
            lineHeight: r(24 / 16)
          },
          "thead th": {
            paddingInlineEnd: e(12, 16),
            paddingBottom: e(12, 16),
            paddingInlineStart: e(12, 16)
          },
          "thead th:first-child": {
            paddingInlineStart: "0"
          },
          "thead th:last-child": {
            paddingInlineEnd: "0"
          },
          "tbody td, tfoot td": {
            paddingTop: e(12, 16),
            paddingInlineEnd: e(12, 16),
            paddingBottom: e(12, 16),
            paddingInlineStart: e(12, 16)
          },
          "tbody td:first-child, tfoot td:first-child": {
            paddingInlineStart: "0"
          },
          "tbody td:last-child, tfoot td:last-child": {
            paddingInlineEnd: "0"
          },
          figure: {
            marginTop: e(32, 18),
            marginBottom: e(32, 18)
          },
          "figure > *": {
            marginTop: "0",
            marginBottom: "0"
          },
          figcaption: {
            fontSize: e(16, 18),
            lineHeight: r(24 / 16),
            marginTop: e(16, 16)
          }
        },
        {
          "> :first-child": {
            marginTop: "0"
          },
          "> :last-child": {
            marginBottom: "0"
          }
        }
      ]
    },
    xl: {
      css: [
        {
          fontSize: T(20),
          lineHeight: r(36 / 20),
          p: {
            marginTop: e(24, 20),
            marginBottom: e(24, 20)
          },
          '[class~="lead"]': {
            fontSize: e(24, 20),
            lineHeight: r(36 / 24),
            marginTop: e(24, 24),
            marginBottom: e(24, 24)
          },
          blockquote: {
            marginTop: e(48, 30),
            marginBottom: e(48, 30),
            paddingInlineStart: e(32, 30)
          },
          h1: {
            fontSize: e(56, 20),
            marginTop: "0",
            marginBottom: e(48, 56),
            lineHeight: r(56 / 56)
          },
          h2: {
            fontSize: e(36, 20),
            marginTop: e(56, 36),
            marginBottom: e(32, 36),
            lineHeight: r(40 / 36)
          },
          h3: {
            fontSize: e(30, 20),
            marginTop: e(48, 30),
            marginBottom: e(20, 30),
            lineHeight: r(40 / 30)
          },
          h4: {
            marginTop: e(36, 20),
            marginBottom: e(12, 20),
            lineHeight: r(32 / 20)
          },
          img: {
            marginTop: e(40, 20),
            marginBottom: e(40, 20)
          },
          picture: {
            marginTop: e(40, 20),
            marginBottom: e(40, 20)
          },
          "picture > img": {
            marginTop: "0",
            marginBottom: "0"
          },
          video: {
            marginTop: e(40, 20),
            marginBottom: e(40, 20)
          },
          kbd: {
            fontSize: e(18, 20),
            borderRadius: T(5),
            paddingTop: e(5, 20),
            paddingInlineEnd: e(8, 20),
            paddingBottom: e(5, 20),
            paddingInlineStart: e(8, 20)
          },
          code: {
            fontSize: e(18, 20)
          },
          "h2 code": {
            fontSize: e(31, 36)
          },
          "h3 code": {
            fontSize: e(27, 30)
          },
          pre: {
            fontSize: e(18, 20),
            lineHeight: r(32 / 18),
            marginTop: e(36, 18),
            marginBottom: e(36, 18),
            borderRadius: T(8),
            paddingTop: e(20, 18),
            paddingInlineEnd: e(24, 18),
            paddingBottom: e(20, 18),
            paddingInlineStart: e(24, 18)
          },
          ol: {
            marginTop: e(24, 20),
            marginBottom: e(24, 20),
            paddingInlineStart: e(32, 20)
          },
          ul: {
            marginTop: e(24, 20),
            marginBottom: e(24, 20),
            paddingInlineStart: e(32, 20)
          },
          li: {
            marginTop: e(12, 20),
            marginBottom: e(12, 20)
          },
          "ol > li": {
            paddingInlineStart: e(8, 20)
          },
          "ul > li": {
            paddingInlineStart: e(8, 20)
          },
          "> ul > li p": {
            marginTop: e(16, 20),
            marginBottom: e(16, 20)
          },
          "> ul > li > p:first-child": {
            marginTop: e(24, 20)
          },
          "> ul > li > p:last-child": {
            marginBottom: e(24, 20)
          },
          "> ol > li > p:first-child": {
            marginTop: e(24, 20)
          },
          "> ol > li > p:last-child": {
            marginBottom: e(24, 20)
          },
          "ul ul, ul ol, ol ul, ol ol": {
            marginTop: e(16, 20),
            marginBottom: e(16, 20)
          },
          dl: {
            marginTop: e(24, 20),
            marginBottom: e(24, 20)
          },
          dt: {
            marginTop: e(24, 20)
          },
          dd: {
            marginTop: e(12, 20),
            paddingInlineStart: e(32, 20)
          },
          hr: {
            marginTop: e(56, 20),
            marginBottom: e(56, 20)
          },
          "hr + *": {
            marginTop: "0"
          },
          "h2 + *": {
            marginTop: "0"
          },
          "h3 + *": {
            marginTop: "0"
          },
          "h4 + *": {
            marginTop: "0"
          },
          table: {
            fontSize: e(18, 20),
            lineHeight: r(28 / 18)
          },
          "thead th": {
            paddingInlineEnd: e(12, 18),
            paddingBottom: e(16, 18),
            paddingInlineStart: e(12, 18)
          },
          "thead th:first-child": {
            paddingInlineStart: "0"
          },
          "thead th:last-child": {
            paddingInlineEnd: "0"
          },
          "tbody td, tfoot td": {
            paddingTop: e(16, 18),
            paddingInlineEnd: e(12, 18),
            paddingBottom: e(16, 18),
            paddingInlineStart: e(12, 18)
          },
          "tbody td:first-child, tfoot td:first-child": {
            paddingInlineStart: "0"
          },
          "tbody td:last-child, tfoot td:last-child": {
            paddingInlineEnd: "0"
          },
          figure: {
            marginTop: e(40, 20),
            marginBottom: e(40, 20)
          },
          "figure > *": {
            marginTop: "0",
            marginBottom: "0"
          },
          figcaption: {
            fontSize: e(18, 20),
            lineHeight: r(28 / 18),
            marginTop: e(18, 18)
          }
        },
        {
          "> :first-child": {
            marginTop: "0"
          },
          "> :last-child": {
            marginBottom: "0"
          }
        }
      ]
    },
    "2xl": {
      css: [
        {
          fontSize: T(24),
          lineHeight: r(40 / 24),
          p: {
            marginTop: e(32, 24),
            marginBottom: e(32, 24)
          },
          '[class~="lead"]': {
            fontSize: e(30, 24),
            lineHeight: r(44 / 30),
            marginTop: e(32, 30),
            marginBottom: e(32, 30)
          },
          blockquote: {
            marginTop: e(64, 36),
            marginBottom: e(64, 36),
            paddingInlineStart: e(40, 36)
          },
          h1: {
            fontSize: e(64, 24),
            marginTop: "0",
            marginBottom: e(56, 64),
            lineHeight: r(64 / 64)
          },
          h2: {
            fontSize: e(48, 24),
            marginTop: e(72, 48),
            marginBottom: e(40, 48),
            lineHeight: r(52 / 48)
          },
          h3: {
            fontSize: e(36, 24),
            marginTop: e(56, 36),
            marginBottom: e(24, 36),
            lineHeight: r(44 / 36)
          },
          h4: {
            marginTop: e(40, 24),
            marginBottom: e(16, 24),
            lineHeight: r(36 / 24)
          },
          img: {
            marginTop: e(48, 24),
            marginBottom: e(48, 24)
          },
          picture: {
            marginTop: e(48, 24),
            marginBottom: e(48, 24)
          },
          "picture > img": {
            marginTop: "0",
            marginBottom: "0"
          },
          video: {
            marginTop: e(48, 24),
            marginBottom: e(48, 24)
          },
          kbd: {
            fontSize: e(20, 24),
            borderRadius: T(6),
            paddingTop: e(6, 24),
            paddingInlineEnd: e(8, 24),
            paddingBottom: e(6, 24),
            paddingInlineStart: e(8, 24)
          },
          code: {
            fontSize: e(20, 24)
          },
          "h2 code": {
            fontSize: e(42, 48)
          },
          "h3 code": {
            fontSize: e(32, 36)
          },
          pre: {
            fontSize: e(20, 24),
            lineHeight: r(36 / 20),
            marginTop: e(40, 20),
            marginBottom: e(40, 20),
            borderRadius: T(8),
            paddingTop: e(24, 20),
            paddingInlineEnd: e(32, 20),
            paddingBottom: e(24, 20),
            paddingInlineStart: e(32, 20)
          },
          ol: {
            marginTop: e(32, 24),
            marginBottom: e(32, 24),
            paddingInlineStart: e(38, 24)
          },
          ul: {
            marginTop: e(32, 24),
            marginBottom: e(32, 24),
            paddingInlineStart: e(38, 24)
          },
          li: {
            marginTop: e(12, 24),
            marginBottom: e(12, 24)
          },
          "ol > li": {
            paddingInlineStart: e(10, 24)
          },
          "ul > li": {
            paddingInlineStart: e(10, 24)
          },
          "> ul > li p": {
            marginTop: e(20, 24),
            marginBottom: e(20, 24)
          },
          "> ul > li > p:first-child": {
            marginTop: e(32, 24)
          },
          "> ul > li > p:last-child": {
            marginBottom: e(32, 24)
          },
          "> ol > li > p:first-child": {
            marginTop: e(32, 24)
          },
          "> ol > li > p:last-child": {
            marginBottom: e(32, 24)
          },
          "ul ul, ul ol, ol ul, ol ol": {
            marginTop: e(16, 24),
            marginBottom: e(16, 24)
          },
          dl: {
            marginTop: e(32, 24),
            marginBottom: e(32, 24)
          },
          dt: {
            marginTop: e(32, 24)
          },
          dd: {
            marginTop: e(12, 24),
            paddingInlineStart: e(38, 24)
          },
          hr: {
            marginTop: e(72, 24),
            marginBottom: e(72, 24)
          },
          "hr + *": {
            marginTop: "0"
          },
          "h2 + *": {
            marginTop: "0"
          },
          "h3 + *": {
            marginTop: "0"
          },
          "h4 + *": {
            marginTop: "0"
          },
          table: {
            fontSize: e(20, 24),
            lineHeight: r(28 / 20)
          },
          "thead th": {
            paddingInlineEnd: e(12, 20),
            paddingBottom: e(16, 20),
            paddingInlineStart: e(12, 20)
          },
          "thead th:first-child": {
            paddingInlineStart: "0"
          },
          "thead th:last-child": {
            paddingInlineEnd: "0"
          },
          "tbody td, tfoot td": {
            paddingTop: e(16, 20),
            paddingInlineEnd: e(12, 20),
            paddingBottom: e(16, 20),
            paddingInlineStart: e(12, 20)
          },
          "tbody td:first-child, tfoot td:first-child": {
            paddingInlineStart: "0"
          },
          "tbody td:last-child, tfoot td:last-child": {
            paddingInlineEnd: "0"
          },
          figure: {
            marginTop: e(48, 24),
            marginBottom: e(48, 24)
          },
          "figure > *": {
            marginTop: "0",
            marginBottom: "0"
          },
          figcaption: {
            fontSize: e(20, 24),
            lineHeight: r(32 / 20),
            marginTop: e(20, 20)
          }
        },
        {
          "> :first-child": {
            marginTop: "0"
          },
          "> :last-child": {
            marginBottom: "0"
          }
        }
      ]
    },
    // Gray color themes
    slate: {
      css: {
        "--tw-prose-body": t.slate[700],
        "--tw-prose-headings": t.slate[900],
        "--tw-prose-lead": t.slate[600],
        "--tw-prose-links": t.slate[900],
        "--tw-prose-bold": t.slate[900],
        "--tw-prose-counters": t.slate[500],
        "--tw-prose-bullets": t.slate[300],
        "--tw-prose-hr": t.slate[200],
        "--tw-prose-quotes": t.slate[900],
        "--tw-prose-quote-borders": t.slate[200],
        "--tw-prose-captions": t.slate[500],
        "--tw-prose-kbd": t.slate[900],
        "--tw-prose-kbd-shadows": f(t.slate[900]),
        "--tw-prose-code": t.slate[900],
        "--tw-prose-pre-code": t.slate[200],
        "--tw-prose-pre-bg": t.slate[800],
        "--tw-prose-th-borders": t.slate[300],
        "--tw-prose-td-borders": t.slate[200],
        "--tw-prose-invert-body": t.slate[300],
        "--tw-prose-invert-headings": t.white,
        "--tw-prose-invert-lead": t.slate[400],
        "--tw-prose-invert-links": t.white,
        "--tw-prose-invert-bold": t.white,
        "--tw-prose-invert-counters": t.slate[400],
        "--tw-prose-invert-bullets": t.slate[600],
        "--tw-prose-invert-hr": t.slate[700],
        "--tw-prose-invert-quotes": t.slate[100],
        "--tw-prose-invert-quote-borders": t.slate[700],
        "--tw-prose-invert-captions": t.slate[400],
        "--tw-prose-invert-kbd": t.white,
        "--tw-prose-invert-kbd-shadows": f(t.white),
        "--tw-prose-invert-code": t.white,
        "--tw-prose-invert-pre-code": t.slate[300],
        "--tw-prose-invert-pre-bg": "rgb(0 0 0 / 50%)",
        "--tw-prose-invert-th-borders": t.slate[600],
        "--tw-prose-invert-td-borders": t.slate[700]
      }
    },
    gray: {
      css: {
        "--tw-prose-body": t.gray[700],
        "--tw-prose-headings": t.gray[900],
        "--tw-prose-lead": t.gray[600],
        "--tw-prose-links": t.gray[900],
        "--tw-prose-bold": t.gray[900],
        "--tw-prose-counters": t.gray[500],
        "--tw-prose-bullets": t.gray[300],
        "--tw-prose-hr": t.gray[200],
        "--tw-prose-quotes": t.gray[900],
        "--tw-prose-quote-borders": t.gray[200],
        "--tw-prose-captions": t.gray[500],
        "--tw-prose-kbd": t.gray[900],
        "--tw-prose-kbd-shadows": f(t.gray[900]),
        "--tw-prose-code": t.gray[900],
        "--tw-prose-pre-code": t.gray[200],
        "--tw-prose-pre-bg": t.gray[800],
        "--tw-prose-th-borders": t.gray[300],
        "--tw-prose-td-borders": t.gray[200],
        "--tw-prose-invert-body": t.gray[300],
        "--tw-prose-invert-headings": t.white,
        "--tw-prose-invert-lead": t.gray[400],
        "--tw-prose-invert-links": t.white,
        "--tw-prose-invert-bold": t.white,
        "--tw-prose-invert-counters": t.gray[400],
        "--tw-prose-invert-bullets": t.gray[600],
        "--tw-prose-invert-hr": t.gray[700],
        "--tw-prose-invert-quotes": t.gray[100],
        "--tw-prose-invert-quote-borders": t.gray[700],
        "--tw-prose-invert-captions": t.gray[400],
        "--tw-prose-invert-kbd": t.white,
        "--tw-prose-invert-kbd-shadows": f(t.white),
        "--tw-prose-invert-code": t.white,
        "--tw-prose-invert-pre-code": t.gray[300],
        "--tw-prose-invert-pre-bg": "rgb(0 0 0 / 50%)",
        "--tw-prose-invert-th-borders": t.gray[600],
        "--tw-prose-invert-td-borders": t.gray[700]
      }
    },
    zinc: {
      css: {
        "--tw-prose-body": t.zinc[700],
        "--tw-prose-headings": t.zinc[900],
        "--tw-prose-lead": t.zinc[600],
        "--tw-prose-links": t.zinc[900],
        "--tw-prose-bold": t.zinc[900],
        "--tw-prose-counters": t.zinc[500],
        "--tw-prose-bullets": t.zinc[300],
        "--tw-prose-hr": t.zinc[200],
        "--tw-prose-quotes": t.zinc[900],
        "--tw-prose-quote-borders": t.zinc[200],
        "--tw-prose-captions": t.zinc[500],
        "--tw-prose-kbd": t.zinc[900],
        "--tw-prose-kbd-shadows": f(t.zinc[900]),
        "--tw-prose-code": t.zinc[900],
        "--tw-prose-pre-code": t.zinc[200],
        "--tw-prose-pre-bg": t.zinc[800],
        "--tw-prose-th-borders": t.zinc[300],
        "--tw-prose-td-borders": t.zinc[200],
        "--tw-prose-invert-body": t.zinc[300],
        "--tw-prose-invert-headings": t.white,
        "--tw-prose-invert-lead": t.zinc[400],
        "--tw-prose-invert-links": t.white,
        "--tw-prose-invert-bold": t.white,
        "--tw-prose-invert-counters": t.zinc[400],
        "--tw-prose-invert-bullets": t.zinc[600],
        "--tw-prose-invert-hr": t.zinc[700],
        "--tw-prose-invert-quotes": t.zinc[100],
        "--tw-prose-invert-quote-borders": t.zinc[700],
        "--tw-prose-invert-captions": t.zinc[400],
        "--tw-prose-invert-kbd": t.white,
        "--tw-prose-invert-kbd-shadows": f(t.white),
        "--tw-prose-invert-code": t.white,
        "--tw-prose-invert-pre-code": t.zinc[300],
        "--tw-prose-invert-pre-bg": "rgb(0 0 0 / 50%)",
        "--tw-prose-invert-th-borders": t.zinc[600],
        "--tw-prose-invert-td-borders": t.zinc[700]
      }
    },
    neutral: {
      css: {
        "--tw-prose-body": t.neutral[700],
        "--tw-prose-headings": t.neutral[900],
        "--tw-prose-lead": t.neutral[600],
        "--tw-prose-links": t.neutral[900],
        "--tw-prose-bold": t.neutral[900],
        "--tw-prose-counters": t.neutral[500],
        "--tw-prose-bullets": t.neutral[300],
        "--tw-prose-hr": t.neutral[200],
        "--tw-prose-quotes": t.neutral[900],
        "--tw-prose-quote-borders": t.neutral[200],
        "--tw-prose-captions": t.neutral[500],
        "--tw-prose-kbd": t.neutral[900],
        "--tw-prose-kbd-shadows": f(t.neutral[900]),
        "--tw-prose-code": t.neutral[900],
        "--tw-prose-pre-code": t.neutral[200],
        "--tw-prose-pre-bg": t.neutral[800],
        "--tw-prose-th-borders": t.neutral[300],
        "--tw-prose-td-borders": t.neutral[200],
        "--tw-prose-invert-body": t.neutral[300],
        "--tw-prose-invert-headings": t.white,
        "--tw-prose-invert-lead": t.neutral[400],
        "--tw-prose-invert-links": t.white,
        "--tw-prose-invert-bold": t.white,
        "--tw-prose-invert-counters": t.neutral[400],
        "--tw-prose-invert-bullets": t.neutral[600],
        "--tw-prose-invert-hr": t.neutral[700],
        "--tw-prose-invert-quotes": t.neutral[100],
        "--tw-prose-invert-quote-borders": t.neutral[700],
        "--tw-prose-invert-captions": t.neutral[400],
        "--tw-prose-invert-kbd": t.white,
        "--tw-prose-invert-kbd-shadows": f(t.white),
        "--tw-prose-invert-code": t.white,
        "--tw-prose-invert-pre-code": t.neutral[300],
        "--tw-prose-invert-pre-bg": "rgb(0 0 0 / 50%)",
        "--tw-prose-invert-th-borders": t.neutral[600],
        "--tw-prose-invert-td-borders": t.neutral[700]
      }
    },
    stone: {
      css: {
        "--tw-prose-body": t.stone[700],
        "--tw-prose-headings": t.stone[900],
        "--tw-prose-lead": t.stone[600],
        "--tw-prose-links": t.stone[900],
        "--tw-prose-bold": t.stone[900],
        "--tw-prose-counters": t.stone[500],
        "--tw-prose-bullets": t.stone[300],
        "--tw-prose-hr": t.stone[200],
        "--tw-prose-quotes": t.stone[900],
        "--tw-prose-quote-borders": t.stone[200],
        "--tw-prose-captions": t.stone[500],
        "--tw-prose-kbd": t.stone[900],
        "--tw-prose-kbd-shadows": f(t.stone[900]),
        "--tw-prose-code": t.stone[900],
        "--tw-prose-pre-code": t.stone[200],
        "--tw-prose-pre-bg": t.stone[800],
        "--tw-prose-th-borders": t.stone[300],
        "--tw-prose-td-borders": t.stone[200],
        "--tw-prose-invert-body": t.stone[300],
        "--tw-prose-invert-headings": t.white,
        "--tw-prose-invert-lead": t.stone[400],
        "--tw-prose-invert-links": t.white,
        "--tw-prose-invert-bold": t.white,
        "--tw-prose-invert-counters": t.stone[400],
        "--tw-prose-invert-bullets": t.stone[600],
        "--tw-prose-invert-hr": t.stone[700],
        "--tw-prose-invert-quotes": t.stone[100],
        "--tw-prose-invert-quote-borders": t.stone[700],
        "--tw-prose-invert-captions": t.stone[400],
        "--tw-prose-invert-kbd": t.white,
        "--tw-prose-invert-kbd-shadows": f(t.white),
        "--tw-prose-invert-code": t.white,
        "--tw-prose-invert-pre-code": t.stone[300],
        "--tw-prose-invert-pre-bg": "rgb(0 0 0 / 50%)",
        "--tw-prose-invert-th-borders": t.stone[600],
        "--tw-prose-invert-td-borders": t.stone[700]
      }
    },
    // Link-only themes (for backward compatibility)
    red: {
      css: {
        "--tw-prose-links": t.red[600],
        "--tw-prose-invert-links": t.red[500]
      }
    },
    orange: {
      css: {
        "--tw-prose-links": t.orange[600],
        "--tw-prose-invert-links": t.orange[500]
      }
    },
    amber: {
      css: {
        "--tw-prose-links": t.amber[600],
        "--tw-prose-invert-links": t.amber[500]
      }
    },
    yellow: {
      css: {
        "--tw-prose-links": t.yellow[600],
        "--tw-prose-invert-links": t.yellow[500]
      }
    },
    lime: {
      css: {
        "--tw-prose-links": t.lime[600],
        "--tw-prose-invert-links": t.lime[500]
      }
    },
    green: {
      css: {
        "--tw-prose-links": t.green[600],
        "--tw-prose-invert-links": t.green[500]
      }
    },
    emerald: {
      css: {
        "--tw-prose-links": t.emerald[600],
        "--tw-prose-invert-links": t.emerald[500]
      }
    },
    teal: {
      css: {
        "--tw-prose-links": t.teal[600],
        "--tw-prose-invert-links": t.teal[500]
      }
    },
    cyan: {
      css: {
        "--tw-prose-links": t.cyan[600],
        "--tw-prose-invert-links": t.cyan[500]
      }
    },
    sky: {
      css: {
        "--tw-prose-links": t.sky[600],
        "--tw-prose-invert-links": t.sky[500]
      }
    },
    blue: {
      css: {
        "--tw-prose-links": t.blue[600],
        "--tw-prose-invert-links": t.blue[500]
      }
    },
    indigo: {
      css: {
        "--tw-prose-links": t.indigo[600],
        "--tw-prose-invert-links": t.indigo[500]
      }
    },
    violet: {
      css: {
        "--tw-prose-links": t.violet[600],
        "--tw-prose-invert-links": t.violet[500]
      }
    },
    purple: {
      css: {
        "--tw-prose-links": t.purple[600],
        "--tw-prose-invert-links": t.purple[500]
      }
    },
    fuchsia: {
      css: {
        "--tw-prose-links": t.fuchsia[600],
        "--tw-prose-invert-links": t.fuchsia[500]
      }
    },
    pink: {
      css: {
        "--tw-prose-links": t.pink[600],
        "--tw-prose-invert-links": t.pink[500]
      }
    },
    rose: {
      css: {
        "--tw-prose-links": t.rose[600],
        "--tw-prose-invert-links": t.rose[500]
      }
    },
    // Invert (for dark mode)
    invert: {
      css: {
        "--tw-prose-body": "var(--tw-prose-invert-body)",
        "--tw-prose-headings": "var(--tw-prose-invert-headings)",
        "--tw-prose-lead": "var(--tw-prose-invert-lead)",
        "--tw-prose-links": "var(--tw-prose-invert-links)",
        "--tw-prose-bold": "var(--tw-prose-invert-bold)",
        "--tw-prose-counters": "var(--tw-prose-invert-counters)",
        "--tw-prose-bullets": "var(--tw-prose-invert-bullets)",
        "--tw-prose-hr": "var(--tw-prose-invert-hr)",
        "--tw-prose-quotes": "var(--tw-prose-invert-quotes)",
        "--tw-prose-quote-borders": "var(--tw-prose-invert-quote-borders)",
        "--tw-prose-captions": "var(--tw-prose-invert-captions)",
        "--tw-prose-kbd": "var(--tw-prose-invert-kbd)",
        "--tw-prose-kbd-shadows": "var(--tw-prose-invert-kbd-shadows)",
        "--tw-prose-code": "var(--tw-prose-invert-code)",
        "--tw-prose-pre-code": "var(--tw-prose-invert-pre-code)",
        "--tw-prose-pre-bg": "var(--tw-prose-invert-pre-bg)",
        "--tw-prose-th-borders": "var(--tw-prose-invert-th-borders)",
        "--tw-prose-td-borders": "var(--tw-prose-invert-td-borders)"
      }
    }
  };
  return Rt = {
    DEFAULT: {
      css: [
        {
          color: "var(--tw-prose-body)",
          maxWidth: "65ch",
          p: {},
          // Required to maintain correct order when merging
          '[class~="lead"]': {
            color: "var(--tw-prose-lead)"
          },
          a: {
            color: "var(--tw-prose-links)",
            textDecoration: "underline",
            fontWeight: "500"
          },
          strong: {
            color: "var(--tw-prose-bold)",
            fontWeight: "600"
          },
          "a strong": {
            color: "inherit"
          },
          "blockquote strong": {
            color: "inherit"
          },
          "thead th strong": {
            color: "inherit"
          },
          ol: {
            listStyleType: "decimal"
          },
          'ol[type="A"]': {
            listStyleType: "upper-alpha"
          },
          'ol[type="a"]': {
            listStyleType: "lower-alpha"
          },
          'ol[type="A" s]': {
            listStyleType: "upper-alpha"
          },
          'ol[type="a" s]': {
            listStyleType: "lower-alpha"
          },
          'ol[type="I"]': {
            listStyleType: "upper-roman"
          },
          'ol[type="i"]': {
            listStyleType: "lower-roman"
          },
          'ol[type="I" s]': {
            listStyleType: "upper-roman"
          },
          'ol[type="i" s]': {
            listStyleType: "lower-roman"
          },
          'ol[type="1"]': {
            listStyleType: "decimal"
          },
          ul: {
            listStyleType: "disc"
          },
          "ol > li::marker": {
            fontWeight: "400",
            color: "var(--tw-prose-counters)"
          },
          "ul > li::marker": {
            color: "var(--tw-prose-bullets)"
          },
          dt: {
            color: "var(--tw-prose-headings)",
            fontWeight: "600"
          },
          hr: {
            borderColor: "var(--tw-prose-hr)",
            borderTopWidth: 1
          },
          blockquote: {
            fontWeight: "500",
            fontStyle: "italic",
            color: "var(--tw-prose-quotes)",
            borderInlineStartWidth: "0.25rem",
            borderInlineStartColor: "var(--tw-prose-quote-borders)",
            quotes: '"\\201C""\\201D""\\2018""\\2019"'
          },
          "blockquote p:first-of-type::before": {
            content: "open-quote"
          },
          "blockquote p:last-of-type::after": {
            content: "close-quote"
          },
          h1: {
            color: "var(--tw-prose-headings)",
            fontWeight: "800"
          },
          "h1 strong": {
            fontWeight: "900",
            color: "inherit"
          },
          h2: {
            color: "var(--tw-prose-headings)",
            fontWeight: "700"
          },
          "h2 strong": {
            fontWeight: "800",
            color: "inherit"
          },
          h3: {
            color: "var(--tw-prose-headings)",
            fontWeight: "600"
          },
          "h3 strong": {
            fontWeight: "700",
            color: "inherit"
          },
          h4: {
            color: "var(--tw-prose-headings)",
            fontWeight: "600"
          },
          "h4 strong": {
            fontWeight: "700",
            color: "inherit"
          },
          img: {},
          // Required to maintain correct order when merging
          picture: {
            display: "block"
          },
          video: {},
          // Required to maintain correct order when merging
          kbd: {
            fontWeight: "500",
            fontFamily: "inherit",
            color: "var(--tw-prose-kbd)",
            boxShadow: "0 0 0 1px rgb(var(--tw-prose-kbd-shadows) / 10%), 0 3px 0 rgb(var(--tw-prose-kbd-shadows) / 10%)"
          },
          code: {
            color: "var(--tw-prose-code)",
            fontWeight: "600"
          },
          "code::before": {
            content: '"`"'
          },
          "code::after": {
            content: '"`"'
          },
          "a code": {
            color: "inherit"
          },
          "h1 code": {
            color: "inherit"
          },
          "h2 code": {
            color: "inherit"
          },
          "h3 code": {
            color: "inherit"
          },
          "h4 code": {
            color: "inherit"
          },
          "blockquote code": {
            color: "inherit"
          },
          "thead th code": {
            color: "inherit"
          },
          pre: {
            color: "var(--tw-prose-pre-code)",
            backgroundColor: "var(--tw-prose-pre-bg)",
            overflowX: "auto",
            fontWeight: "400"
          },
          "pre code": {
            backgroundColor: "transparent",
            borderWidth: "0",
            borderRadius: "0",
            padding: "0",
            fontWeight: "inherit",
            color: "inherit",
            fontSize: "inherit",
            fontFamily: "inherit",
            lineHeight: "inherit"
          },
          "pre code::before": {
            content: "none"
          },
          "pre code::after": {
            content: "none"
          },
          table: {
            width: "100%",
            tableLayout: "auto",
            marginTop: e(32, 16),
            marginBottom: e(32, 16)
          },
          thead: {
            borderBottomWidth: "1px",
            borderBottomColor: "var(--tw-prose-th-borders)"
          },
          "thead th": {
            color: "var(--tw-prose-headings)",
            fontWeight: "600",
            verticalAlign: "bottom"
          },
          "tbody tr": {
            borderBottomWidth: "1px",
            borderBottomColor: "var(--tw-prose-td-borders)"
          },
          "tbody tr:last-child": {
            borderBottomWidth: "0"
          },
          "tbody td": {
            verticalAlign: "baseline"
          },
          tfoot: {
            borderTopWidth: "1px",
            borderTopColor: "var(--tw-prose-th-borders)"
          },
          "tfoot td": {
            verticalAlign: "top"
          },
          "th, td": {
            textAlign: "start"
          },
          "figure > *": {},
          // Required to maintain correct order when merging
          figcaption: {
            color: "var(--tw-prose-captions)"
          }
        },
        w.gray.css,
        ...w.base.css
      ]
    },
    ...w
  }, Rt;
}
var Ft, vr;
function qi() {
  if (vr) return Ft;
  vr = 1;
  var t = "[object Object]";
  function r(d) {
    var O = !1;
    if (d != null && typeof d.toString != "function")
      try {
        O = !!(d + "");
      } catch {
      }
    return O;
  }
  function T(d, O) {
    return function(P) {
      return d(O(P));
    };
  }
  var e = Function.prototype, f = Object.prototype, w = e.toString, p = f.hasOwnProperty, v = w.call(Object), n = f.toString, o = T(Object.getPrototypeOf, Object);
  function s(d) {
    return !!d && typeof d == "object";
  }
  function u(d) {
    if (!s(d) || n.call(d) != t || r(d))
      return !1;
    var O = o(d);
    if (O === null)
      return !0;
    var P = p.call(O, "constructor") && O.constructor;
    return typeof P == "function" && P instanceof P && w.call(P) == v;
  }
  return Ft = u, Ft;
}
var Ye = { exports: {} }, Qe = { exports: {} }, Ve = { exports: {} }, Ke = { exports: {} }, Xe = { exports: {} }, Je = { exports: {} }, Te = {}, Ze = { exports: {} }, mr;
function Zr() {
  return mr || (mr = 1, function(t, r) {
    r.__esModule = !0, r.default = f;
    function T(w) {
      for (var p = w.toLowerCase(), v = "", n = !1, o = 0; o < 6 && p[o] !== void 0; o++) {
        var s = p.charCodeAt(o), u = s >= 97 && s <= 102 || s >= 48 && s <= 57;
        if (n = s === 32, !u)
          break;
        v += p[o];
      }
      if (v.length !== 0) {
        var d = parseInt(v, 16), O = d >= 55296 && d <= 57343;
        return O || d === 0 || d > 1114111 ? ["�", v.length + (n ? 1 : 0)] : [String.fromCodePoint(d), v.length + (n ? 1 : 0)];
      }
    }
    var e = /\\/;
    function f(w) {
      var p = e.test(w);
      if (!p)
        return w;
      for (var v = "", n = 0; n < w.length; n++) {
        if (w[n] === "\\") {
          var o = T(w.slice(n + 1, n + 7));
          if (o !== void 0) {
            v += o[0], n += o[1];
            continue;
          }
          if (w[n + 1] === "\\") {
            v += "\\", n++;
            continue;
          }
          w.length === n + 1 && (v += w[n]);
          continue;
        }
        v += w[n];
      }
      return v;
    }
    t.exports = r.default;
  }(Ze, Ze.exports)), Ze.exports;
}
var et = { exports: {} }, wr;
function Ai() {
  return wr || (wr = 1, function(t, r) {
    r.__esModule = !0, r.default = T;
    function T(e) {
      for (var f = arguments.length, w = new Array(f > 1 ? f - 1 : 0), p = 1; p < f; p++)
        w[p - 1] = arguments[p];
      for (; w.length > 0; ) {
        var v = w.shift();
        if (!e[v])
          return;
        e = e[v];
      }
      return e;
    }
    t.exports = r.default;
  }(et, et.exports)), et.exports;
}
var tt = { exports: {} }, _r;
function Di() {
  return _r || (_r = 1, function(t, r) {
    r.__esModule = !0, r.default = T;
    function T(e) {
      for (var f = arguments.length, w = new Array(f > 1 ? f - 1 : 0), p = 1; p < f; p++)
        w[p - 1] = arguments[p];
      for (; w.length > 0; ) {
        var v = w.shift();
        e[v] || (e[v] = {}), e = e[v];
      }
    }
    t.exports = r.default;
  }(tt, tt.exports)), tt.exports;
}
var rt = { exports: {} }, br;
function Bi() {
  return br || (br = 1, function(t, r) {
    r.__esModule = !0, r.default = T;
    function T(e) {
      for (var f = "", w = e.indexOf("/*"), p = 0; w >= 0; ) {
        f = f + e.slice(p, w);
        var v = e.indexOf("*/", w + 2);
        if (v < 0)
          return f;
        p = v + 2, w = e.indexOf("/*", p);
      }
      return f = f + e.slice(p), f;
    }
    t.exports = r.default;
  }(rt, rt.exports)), rt.exports;
}
var Tr;
function gt() {
  if (Tr) return Te;
  Tr = 1, Te.__esModule = !0, Te.stripComments = Te.ensureObject = Te.getProp = Te.unesc = void 0;
  var t = f(Zr());
  Te.unesc = t.default;
  var r = f(Ai());
  Te.getProp = r.default;
  var T = f(Di());
  Te.ensureObject = T.default;
  var e = f(Bi());
  Te.stripComments = e.default;
  function f(w) {
    return w && w.__esModule ? w : { default: w };
  }
  return Te;
}
var yr;
function Oe() {
  return yr || (yr = 1, function(t, r) {
    r.__esModule = !0, r.default = void 0;
    var T = gt();
    function e(v, n) {
      for (var o = 0; o < n.length; o++) {
        var s = n[o];
        s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(v, s.key, s);
      }
    }
    function f(v, n, o) {
      return n && e(v.prototype, n), v;
    }
    var w = function v(n, o) {
      if (typeof n != "object" || n === null)
        return n;
      var s = new n.constructor();
      for (var u in n)
        if (n.hasOwnProperty(u)) {
          var d = n[u], O = typeof d;
          u === "parent" && O === "object" ? o && (s[u] = o) : d instanceof Array ? s[u] = d.map(function(P) {
            return v(P, s);
          }) : s[u] = v(d, s);
        }
      return s;
    }, p = /* @__PURE__ */ function() {
      function v(o) {
        o === void 0 && (o = {}), Object.assign(this, o), this.spaces = this.spaces || {}, this.spaces.before = this.spaces.before || "", this.spaces.after = this.spaces.after || "";
      }
      var n = v.prototype;
      return n.remove = function() {
        return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
      }, n.replaceWith = function() {
        if (this.parent) {
          for (var s in arguments)
            this.parent.insertBefore(this, arguments[s]);
          this.remove();
        }
        return this;
      }, n.next = function() {
        return this.parent.at(this.parent.index(this) + 1);
      }, n.prev = function() {
        return this.parent.at(this.parent.index(this) - 1);
      }, n.clone = function(s) {
        s === void 0 && (s = {});
        var u = w(this);
        for (var d in s)
          u[d] = s[d];
        return u;
      }, n.appendToPropertyAndEscape = function(s, u, d) {
        this.raws || (this.raws = {});
        var O = this[s], P = this.raws[s];
        this[s] = O + u, P || d !== u ? this.raws[s] = (P || O) + d : delete this.raws[s];
      }, n.setPropertyAndEscape = function(s, u, d) {
        this.raws || (this.raws = {}), this[s] = u, this.raws[s] = d;
      }, n.setPropertyWithoutEscape = function(s, u) {
        this[s] = u, this.raws && delete this.raws[s];
      }, n.isAtPosition = function(s, u) {
        if (this.source && this.source.start && this.source.end)
          return !(this.source.start.line > s || this.source.end.line < s || this.source.start.line === s && this.source.start.column > u || this.source.end.line === s && this.source.end.column < u);
      }, n.stringifyProperty = function(s) {
        return this.raws && this.raws[s] || this[s];
      }, n.valueToString = function() {
        return String(this.stringifyProperty("value"));
      }, n.toString = function() {
        return [this.rawSpaceBefore, this.valueToString(), this.rawSpaceAfter].join("");
      }, f(v, [{
        key: "rawSpaceBefore",
        get: function() {
          var s = this.raws && this.raws.spaces && this.raws.spaces.before;
          return s === void 0 && (s = this.spaces && this.spaces.before), s || "";
        },
        set: function(s) {
          (0, T.ensureObject)(this, "raws", "spaces"), this.raws.spaces.before = s;
        }
      }, {
        key: "rawSpaceAfter",
        get: function() {
          var s = this.raws && this.raws.spaces && this.raws.spaces.after;
          return s === void 0 && (s = this.spaces.after), s || "";
        },
        set: function(s) {
          (0, T.ensureObject)(this, "raws", "spaces"), this.raws.spaces.after = s;
        }
      }]), v;
    }();
    r.default = p, t.exports = r.default;
  }(Je, Je.exports)), Je.exports;
}
var J = {}, Sr;
function le() {
  if (Sr) return J;
  Sr = 1, J.__esModule = !0, J.UNIVERSAL = J.ATTRIBUTE = J.CLASS = J.COMBINATOR = J.COMMENT = J.ID = J.NESTING = J.PSEUDO = J.ROOT = J.SELECTOR = J.STRING = J.TAG = void 0;
  var t = "tag";
  J.TAG = t;
  var r = "string";
  J.STRING = r;
  var T = "selector";
  J.SELECTOR = T;
  var e = "root";
  J.ROOT = e;
  var f = "pseudo";
  J.PSEUDO = f;
  var w = "nesting";
  J.NESTING = w;
  var p = "id";
  J.ID = p;
  var v = "comment";
  J.COMMENT = v;
  var n = "combinator";
  J.COMBINATOR = n;
  var o = "class";
  J.CLASS = o;
  var s = "attribute";
  J.ATTRIBUTE = s;
  var u = "universal";
  return J.UNIVERSAL = u, J;
}
var Or;
function Ht() {
  return Or || (Or = 1, function(t, r) {
    r.__esModule = !0, r.default = void 0;
    var T = p(Oe()), e = w(le());
    function f() {
      if (typeof WeakMap != "function") return null;
      var a = /* @__PURE__ */ new WeakMap();
      return f = function() {
        return a;
      }, a;
    }
    function w(a) {
      if (a && a.__esModule)
        return a;
      if (a === null || typeof a != "object" && typeof a != "function")
        return { default: a };
      var c = f();
      if (c && c.has(a))
        return c.get(a);
      var m = {}, _ = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var y in a)
        if (Object.prototype.hasOwnProperty.call(a, y)) {
          var I = _ ? Object.getOwnPropertyDescriptor(a, y) : null;
          I && (I.get || I.set) ? Object.defineProperty(m, y, I) : m[y] = a[y];
        }
      return m.default = a, c && c.set(a, m), m;
    }
    function p(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function v(a, c) {
      var m;
      if (typeof Symbol > "u" || a[Symbol.iterator] == null) {
        if (Array.isArray(a) || (m = n(a)) || c) {
          m && (a = m);
          var _ = 0;
          return function() {
            return _ >= a.length ? { done: !0 } : { done: !1, value: a[_++] };
          };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      return m = a[Symbol.iterator](), m.next.bind(m);
    }
    function n(a, c) {
      if (a) {
        if (typeof a == "string") return o(a, c);
        var m = Object.prototype.toString.call(a).slice(8, -1);
        if (m === "Object" && a.constructor && (m = a.constructor.name), m === "Map" || m === "Set") return Array.from(a);
        if (m === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(m)) return o(a, c);
      }
    }
    function o(a, c) {
      (c == null || c > a.length) && (c = a.length);
      for (var m = 0, _ = new Array(c); m < c; m++)
        _[m] = a[m];
      return _;
    }
    function s(a, c) {
      for (var m = 0; m < c.length; m++) {
        var _ = c[m];
        _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(a, _.key, _);
      }
    }
    function u(a, c, m) {
      return c && s(a.prototype, c), a;
    }
    function d(a, c) {
      a.prototype = Object.create(c.prototype), a.prototype.constructor = a, O(a, c);
    }
    function O(a, c) {
      return O = Object.setPrototypeOf || function(_, y) {
        return _.__proto__ = y, _;
      }, O(a, c);
    }
    var P = /* @__PURE__ */ function(a) {
      d(c, a);
      function c(_) {
        var y;
        return y = a.call(this, _) || this, y.nodes || (y.nodes = []), y;
      }
      var m = c.prototype;
      return m.append = function(y) {
        return y.parent = this, this.nodes.push(y), this;
      }, m.prepend = function(y) {
        return y.parent = this, this.nodes.unshift(y), this;
      }, m.at = function(y) {
        return this.nodes[y];
      }, m.index = function(y) {
        return typeof y == "number" ? y : this.nodes.indexOf(y);
      }, m.removeChild = function(y) {
        y = this.index(y), this.at(y).parent = void 0, this.nodes.splice(y, 1);
        var I;
        for (var h in this.indexes)
          I = this.indexes[h], I >= y && (this.indexes[h] = I - 1);
        return this;
      }, m.removeAll = function() {
        for (var y = v(this.nodes), I; !(I = y()).done; ) {
          var h = I.value;
          h.parent = void 0;
        }
        return this.nodes = [], this;
      }, m.empty = function() {
        return this.removeAll();
      }, m.insertAfter = function(y, I) {
        I.parent = this;
        var h = this.index(y);
        this.nodes.splice(h + 1, 0, I), I.parent = this;
        var x;
        for (var F in this.indexes)
          x = this.indexes[F], h <= x && (this.indexes[F] = x + 1);
        return this;
      }, m.insertBefore = function(y, I) {
        I.parent = this;
        var h = this.index(y);
        this.nodes.splice(h, 0, I), I.parent = this;
        var x;
        for (var F in this.indexes)
          x = this.indexes[F], x <= h && (this.indexes[F] = x + 1);
        return this;
      }, m._findChildAtPosition = function(y, I) {
        var h = void 0;
        return this.each(function(x) {
          if (x.atPosition) {
            var F = x.atPosition(y, I);
            if (F)
              return h = F, !1;
          } else if (x.isAtPosition(y, I))
            return h = x, !1;
        }), h;
      }, m.atPosition = function(y, I) {
        if (this.isAtPosition(y, I))
          return this._findChildAtPosition(y, I) || this;
      }, m._inferEndPosition = function() {
        this.last && this.last.source && this.last.source.end && (this.source = this.source || {}, this.source.end = this.source.end || {}, Object.assign(this.source.end, this.last.source.end));
      }, m.each = function(y) {
        this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach++;
        var I = this.lastEach;
        if (this.indexes[I] = 0, !!this.length) {
          for (var h, x; this.indexes[I] < this.length && (h = this.indexes[I], x = y(this.at(h), h), x !== !1); )
            this.indexes[I] += 1;
          if (delete this.indexes[I], x === !1)
            return !1;
        }
      }, m.walk = function(y) {
        return this.each(function(I, h) {
          var x = y(I, h);
          if (x !== !1 && I.length && (x = I.walk(y)), x === !1)
            return !1;
        });
      }, m.walkAttributes = function(y) {
        var I = this;
        return this.walk(function(h) {
          if (h.type === e.ATTRIBUTE)
            return y.call(I, h);
        });
      }, m.walkClasses = function(y) {
        var I = this;
        return this.walk(function(h) {
          if (h.type === e.CLASS)
            return y.call(I, h);
        });
      }, m.walkCombinators = function(y) {
        var I = this;
        return this.walk(function(h) {
          if (h.type === e.COMBINATOR)
            return y.call(I, h);
        });
      }, m.walkComments = function(y) {
        var I = this;
        return this.walk(function(h) {
          if (h.type === e.COMMENT)
            return y.call(I, h);
        });
      }, m.walkIds = function(y) {
        var I = this;
        return this.walk(function(h) {
          if (h.type === e.ID)
            return y.call(I, h);
        });
      }, m.walkNesting = function(y) {
        var I = this;
        return this.walk(function(h) {
          if (h.type === e.NESTING)
            return y.call(I, h);
        });
      }, m.walkPseudos = function(y) {
        var I = this;
        return this.walk(function(h) {
          if (h.type === e.PSEUDO)
            return y.call(I, h);
        });
      }, m.walkTags = function(y) {
        var I = this;
        return this.walk(function(h) {
          if (h.type === e.TAG)
            return y.call(I, h);
        });
      }, m.walkUniversals = function(y) {
        var I = this;
        return this.walk(function(h) {
          if (h.type === e.UNIVERSAL)
            return y.call(I, h);
        });
      }, m.split = function(y) {
        var I = this, h = [];
        return this.reduce(function(x, F, D) {
          var E = y.call(I, F);
          return h.push(F), E ? (x.push(h), h = []) : D === I.length - 1 && x.push(h), x;
        }, []);
      }, m.map = function(y) {
        return this.nodes.map(y);
      }, m.reduce = function(y, I) {
        return this.nodes.reduce(y, I);
      }, m.every = function(y) {
        return this.nodes.every(y);
      }, m.some = function(y) {
        return this.nodes.some(y);
      }, m.filter = function(y) {
        return this.nodes.filter(y);
      }, m.sort = function(y) {
        return this.nodes.sort(y);
      }, m.toString = function() {
        return this.map(String).join("");
      }, u(c, [{
        key: "first",
        get: function() {
          return this.at(0);
        }
      }, {
        key: "last",
        get: function() {
          return this.at(this.length - 1);
        }
      }, {
        key: "length",
        get: function() {
          return this.nodes.length;
        }
      }]), c;
    }(T.default);
    r.default = P, t.exports = r.default;
  }(Xe, Xe.exports)), Xe.exports;
}
var Er;
function en() {
  return Er || (Er = 1, function(t, r) {
    r.__esModule = !0, r.default = void 0;
    var T = f(Ht()), e = le();
    function f(s) {
      return s && s.__esModule ? s : { default: s };
    }
    function w(s, u) {
      for (var d = 0; d < u.length; d++) {
        var O = u[d];
        O.enumerable = O.enumerable || !1, O.configurable = !0, "value" in O && (O.writable = !0), Object.defineProperty(s, O.key, O);
      }
    }
    function p(s, u, d) {
      return u && w(s.prototype, u), s;
    }
    function v(s, u) {
      s.prototype = Object.create(u.prototype), s.prototype.constructor = s, n(s, u);
    }
    function n(s, u) {
      return n = Object.setPrototypeOf || function(O, P) {
        return O.__proto__ = P, O;
      }, n(s, u);
    }
    var o = /* @__PURE__ */ function(s) {
      v(u, s);
      function u(O) {
        var P;
        return P = s.call(this, O) || this, P.type = e.ROOT, P;
      }
      var d = u.prototype;
      return d.toString = function() {
        var P = this.reduce(function(a, c) {
          return a.push(String(c)), a;
        }, []).join(",");
        return this.trailingComma ? P + "," : P;
      }, d.error = function(P, a) {
        return this._error ? this._error(P, a) : new Error(P);
      }, p(u, [{
        key: "errorGenerator",
        set: function(P) {
          this._error = P;
        }
      }]), u;
    }(T.default);
    r.default = o, t.exports = r.default;
  }(Ke, Ke.exports)), Ke.exports;
}
var nt = { exports: {} }, kr;
function tn() {
  return kr || (kr = 1, function(t, r) {
    r.__esModule = !0, r.default = void 0;
    var T = f(Ht()), e = le();
    function f(n) {
      return n && n.__esModule ? n : { default: n };
    }
    function w(n, o) {
      n.prototype = Object.create(o.prototype), n.prototype.constructor = n, p(n, o);
    }
    function p(n, o) {
      return p = Object.setPrototypeOf || function(u, d) {
        return u.__proto__ = d, u;
      }, p(n, o);
    }
    var v = /* @__PURE__ */ function(n) {
      w(o, n);
      function o(s) {
        var u;
        return u = n.call(this, s) || this, u.type = e.SELECTOR, u;
      }
      return o;
    }(T.default);
    r.default = v, t.exports = r.default;
  }(nt, nt.exports)), nt.exports;
}
var it = { exports: {} };
/*! https://mths.be/cssesc v3.0.0 by @mathias */
var Ct, Ir;
function jt() {
  if (Ir) return Ct;
  Ir = 1;
  var t = {}, r = t.hasOwnProperty, T = function(n, o) {
    if (!n)
      return o;
    var s = {};
    for (var u in o)
      s[u] = r.call(n, u) ? n[u] : o[u];
    return s;
  }, e = /[ -,\.\/:-@\[-\^`\{-~]/, f = /[ -,\.\/:-@\[\]\^`\{-~]/, w = /(^|\\+)?(\\[A-F0-9]{1,6})\x20(?![a-fA-F0-9\x20])/g, p = function v(n, o) {
    o = T(o, v.options), o.quotes != "single" && o.quotes != "double" && (o.quotes = "single");
    for (var s = o.quotes == "double" ? '"' : "'", u = o.isIdentifier, d = n.charAt(0), O = "", P = 0, a = n.length; P < a; ) {
      var c = n.charAt(P++), m = c.charCodeAt(), _ = void 0;
      if (m < 32 || m > 126) {
        if (m >= 55296 && m <= 56319 && P < a) {
          var y = n.charCodeAt(P++);
          (y & 64512) == 56320 ? m = ((m & 1023) << 10) + (y & 1023) + 65536 : P--;
        }
        _ = "\\" + m.toString(16).toUpperCase() + " ";
      } else
        o.escapeEverything ? e.test(c) ? _ = "\\" + c : _ = "\\" + m.toString(16).toUpperCase() + " " : /[\t\n\f\r\x0B]/.test(c) ? _ = "\\" + m.toString(16).toUpperCase() + " " : c == "\\" || !u && (c == '"' && s == c || c == "'" && s == c) || u && f.test(c) ? _ = "\\" + c : _ = c;
      O += _;
    }
    return u && (/^-[-\d]/.test(O) ? O = "\\-" + O.slice(1) : /\d/.test(d) && (O = "\\3" + d + " " + O.slice(1))), O = O.replace(w, function(I, h, x) {
      return h && h.length % 2 ? I : (h || "") + x;
    }), !u && o.wrap ? s + O + s : O;
  };
  return p.options = {
    escapeEverything: !1,
    isIdentifier: !1,
    quotes: "single",
    wrap: !1
  }, p.version = "3.0.0", Ct = p, Ct;
}
var Pr;
function rn() {
  return Pr || (Pr = 1, function(t, r) {
    r.__esModule = !0, r.default = void 0;
    var T = p(jt()), e = gt(), f = p(Oe()), w = le();
    function p(d) {
      return d && d.__esModule ? d : { default: d };
    }
    function v(d, O) {
      for (var P = 0; P < O.length; P++) {
        var a = O[P];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(d, a.key, a);
      }
    }
    function n(d, O, P) {
      return O && v(d.prototype, O), d;
    }
    function o(d, O) {
      d.prototype = Object.create(O.prototype), d.prototype.constructor = d, s(d, O);
    }
    function s(d, O) {
      return s = Object.setPrototypeOf || function(a, c) {
        return a.__proto__ = c, a;
      }, s(d, O);
    }
    var u = /* @__PURE__ */ function(d) {
      o(O, d);
      function O(a) {
        var c;
        return c = d.call(this, a) || this, c.type = w.CLASS, c._constructed = !0, c;
      }
      var P = O.prototype;
      return P.valueToString = function() {
        return "." + d.prototype.valueToString.call(this);
      }, n(O, [{
        key: "value",
        get: function() {
          return this._value;
        },
        set: function(c) {
          if (this._constructed) {
            var m = (0, T.default)(c, {
              isIdentifier: !0
            });
            m !== c ? ((0, e.ensureObject)(this, "raws"), this.raws.value = m) : this.raws && delete this.raws.value;
          }
          this._value = c;
        }
      }]), O;
    }(f.default);
    r.default = u, t.exports = r.default;
  }(it, it.exports)), it.exports;
}
var at = { exports: {} }, xr;
function nn() {
  return xr || (xr = 1, function(t, r) {
    r.__esModule = !0, r.default = void 0;
    var T = f(Oe()), e = le();
    function f(n) {
      return n && n.__esModule ? n : { default: n };
    }
    function w(n, o) {
      n.prototype = Object.create(o.prototype), n.prototype.constructor = n, p(n, o);
    }
    function p(n, o) {
      return p = Object.setPrototypeOf || function(u, d) {
        return u.__proto__ = d, u;
      }, p(n, o);
    }
    var v = /* @__PURE__ */ function(n) {
      w(o, n);
      function o(s) {
        var u;
        return u = n.call(this, s) || this, u.type = e.COMMENT, u;
      }
      return o;
    }(T.default);
    r.default = v, t.exports = r.default;
  }(at, at.exports)), at.exports;
}
var ot = { exports: {} }, qr;
function an() {
  return qr || (qr = 1, function(t, r) {
    r.__esModule = !0, r.default = void 0;
    var T = f(Oe()), e = le();
    function f(n) {
      return n && n.__esModule ? n : { default: n };
    }
    function w(n, o) {
      n.prototype = Object.create(o.prototype), n.prototype.constructor = n, p(n, o);
    }
    function p(n, o) {
      return p = Object.setPrototypeOf || function(u, d) {
        return u.__proto__ = d, u;
      }, p(n, o);
    }
    var v = /* @__PURE__ */ function(n) {
      w(o, n);
      function o(u) {
        var d;
        return d = n.call(this, u) || this, d.type = e.ID, d;
      }
      var s = o.prototype;
      return s.valueToString = function() {
        return "#" + n.prototype.valueToString.call(this);
      }, o;
    }(T.default);
    r.default = v, t.exports = r.default;
  }(ot, ot.exports)), ot.exports;
}
var st = { exports: {} }, ut = { exports: {} }, Ar;
function Gt() {
  return Ar || (Ar = 1, function(t, r) {
    r.__esModule = !0, r.default = void 0;
    var T = w(jt()), e = gt(), f = w(Oe());
    function w(u) {
      return u && u.__esModule ? u : { default: u };
    }
    function p(u, d) {
      for (var O = 0; O < d.length; O++) {
        var P = d[O];
        P.enumerable = P.enumerable || !1, P.configurable = !0, "value" in P && (P.writable = !0), Object.defineProperty(u, P.key, P);
      }
    }
    function v(u, d, O) {
      return d && p(u.prototype, d), u;
    }
    function n(u, d) {
      u.prototype = Object.create(d.prototype), u.prototype.constructor = u, o(u, d);
    }
    function o(u, d) {
      return o = Object.setPrototypeOf || function(P, a) {
        return P.__proto__ = a, P;
      }, o(u, d);
    }
    var s = /* @__PURE__ */ function(u) {
      n(d, u);
      function d() {
        return u.apply(this, arguments) || this;
      }
      var O = d.prototype;
      return O.qualifiedName = function(a) {
        return this.namespace ? this.namespaceString + "|" + a : a;
      }, O.valueToString = function() {
        return this.qualifiedName(u.prototype.valueToString.call(this));
      }, v(d, [{
        key: "namespace",
        get: function() {
          return this._namespace;
        },
        set: function(a) {
          if (a === !0 || a === "*" || a === "&") {
            this._namespace = a, this.raws && delete this.raws.namespace;
            return;
          }
          var c = (0, T.default)(a, {
            isIdentifier: !0
          });
          this._namespace = a, c !== a ? ((0, e.ensureObject)(this, "raws"), this.raws.namespace = c) : this.raws && delete this.raws.namespace;
        }
      }, {
        key: "ns",
        get: function() {
          return this._namespace;
        },
        set: function(a) {
          this.namespace = a;
        }
      }, {
        key: "namespaceString",
        get: function() {
          if (this.namespace) {
            var a = this.stringifyProperty("namespace");
            return a === !0 ? "" : a;
          } else
            return "";
        }
      }]), d;
    }(f.default);
    r.default = s, t.exports = r.default;
  }(ut, ut.exports)), ut.exports;
}
var Dr;
function on() {
  return Dr || (Dr = 1, function(t, r) {
    r.__esModule = !0, r.default = void 0;
    var T = f(Gt()), e = le();
    function f(n) {
      return n && n.__esModule ? n : { default: n };
    }
    function w(n, o) {
      n.prototype = Object.create(o.prototype), n.prototype.constructor = n, p(n, o);
    }
    function p(n, o) {
      return p = Object.setPrototypeOf || function(u, d) {
        return u.__proto__ = d, u;
      }, p(n, o);
    }
    var v = /* @__PURE__ */ function(n) {
      w(o, n);
      function o(s) {
        var u;
        return u = n.call(this, s) || this, u.type = e.TAG, u;
      }
      return o;
    }(T.default);
    r.default = v, t.exports = r.default;
  }(st, st.exports)), st.exports;
}
var lt = { exports: {} }, Br;
function sn() {
  return Br || (Br = 1, function(t, r) {
    r.__esModule = !0, r.default = void 0;
    var T = f(Oe()), e = le();
    function f(n) {
      return n && n.__esModule ? n : { default: n };
    }
    function w(n, o) {
      n.prototype = Object.create(o.prototype), n.prototype.constructor = n, p(n, o);
    }
    function p(n, o) {
      return p = Object.setPrototypeOf || function(u, d) {
        return u.__proto__ = d, u;
      }, p(n, o);
    }
    var v = /* @__PURE__ */ function(n) {
      w(o, n);
      function o(s) {
        var u;
        return u = n.call(this, s) || this, u.type = e.STRING, u;
      }
      return o;
    }(T.default);
    r.default = v, t.exports = r.default;
  }(lt, lt.exports)), lt.exports;
}
var ct = { exports: {} }, Lr;
function un() {
  return Lr || (Lr = 1, function(t, r) {
    r.__esModule = !0, r.default = void 0;
    var T = f(Ht()), e = le();
    function f(n) {
      return n && n.__esModule ? n : { default: n };
    }
    function w(n, o) {
      n.prototype = Object.create(o.prototype), n.prototype.constructor = n, p(n, o);
    }
    function p(n, o) {
      return p = Object.setPrototypeOf || function(u, d) {
        return u.__proto__ = d, u;
      }, p(n, o);
    }
    var v = /* @__PURE__ */ function(n) {
      w(o, n);
      function o(u) {
        var d;
        return d = n.call(this, u) || this, d.type = e.PSEUDO, d;
      }
      var s = o.prototype;
      return s.toString = function() {
        var d = this.length ? "(" + this.map(String).join(",") + ")" : "";
        return [this.rawSpaceBefore, this.stringifyProperty("value"), d, this.rawSpaceAfter].join("");
      }, o;
    }(T.default);
    r.default = v, t.exports = r.default;
  }(ct, ct.exports)), ct.exports;
}
var Mt = {}, Nt, Rr;
function Li() {
  if (Rr) return Nt;
  Rr = 1, Nt = t;
  function t(T, e) {
    if (r("noDeprecation"))
      return T;
    var f = !1;
    function w() {
      if (!f) {
        if (r("throwDeprecation"))
          throw new Error(e);
        r("traceDeprecation") ? console.trace(e) : console.warn(e), f = !0;
      }
      return T.apply(this, arguments);
    }
    return w;
  }
  function r(T) {
    try {
      if (!Be.localStorage) return !1;
    } catch {
      return !1;
    }
    var e = Be.localStorage[T];
    return e == null ? !1 : String(e).toLowerCase() === "true";
  }
  return Nt;
}
var Fr;
function ln() {
  return Fr || (Fr = 1, function(t) {
    t.__esModule = !0, t.unescapeValue = c, t.default = void 0;
    var r = p(jt()), T = p(Zr()), e = p(Gt()), f = le(), w;
    function p(h) {
      return h && h.__esModule ? h : { default: h };
    }
    function v(h, x) {
      for (var F = 0; F < x.length; F++) {
        var D = x[F];
        D.enumerable = D.enumerable || !1, D.configurable = !0, "value" in D && (D.writable = !0), Object.defineProperty(h, D.key, D);
      }
    }
    function n(h, x, F) {
      return x && v(h.prototype, x), h;
    }
    function o(h, x) {
      h.prototype = Object.create(x.prototype), h.prototype.constructor = h, s(h, x);
    }
    function s(h, x) {
      return s = Object.setPrototypeOf || function(D, E) {
        return D.__proto__ = E, D;
      }, s(h, x);
    }
    var u = Li(), d = /^('|")([^]*)\1$/, O = u(function() {
    }, "Assigning an attribute a value containing characters that might need to be escaped is deprecated. Call attribute.setValue() instead."), P = u(function() {
    }, "Assigning attr.quoted is deprecated and has no effect. Assign to attr.quoteMark instead."), a = u(function() {
    }, "Constructing an Attribute selector with a value without specifying quoteMark is deprecated. Note: The value should be unescaped now.");
    function c(h) {
      var x = !1, F = null, D = h, E = D.match(d);
      return E && (F = E[1], D = E[2]), D = (0, T.default)(D), D !== h && (x = !0), {
        deprecatedUsage: x,
        unescaped: D,
        quoteMark: F
      };
    }
    function m(h) {
      if (h.quoteMark !== void 0 || h.value === void 0)
        return h;
      a();
      var x = c(h.value), F = x.quoteMark, D = x.unescaped;
      return h.raws || (h.raws = {}), h.raws.value === void 0 && (h.raws.value = h.value), h.value = D, h.quoteMark = F, h;
    }
    var _ = /* @__PURE__ */ function(h) {
      o(x, h);
      function x(D) {
        var E;
        return D === void 0 && (D = {}), E = h.call(this, m(D)) || this, E.type = f.ATTRIBUTE, E.raws = E.raws || {}, Object.defineProperty(E.raws, "unquoted", {
          get: u(function() {
            return E.value;
          }, "attr.raws.unquoted is deprecated. Call attr.value instead."),
          set: u(function() {
            return E.value;
          }, "Setting attr.raws.unquoted is deprecated and has no effect. attr.value is unescaped by default now.")
        }), E._constructed = !0, E;
      }
      var F = x.prototype;
      return F.getQuotedValue = function(E) {
        E === void 0 && (E = {});
        var k = this._determineQuoteMark(E), $ = y[k], Y = (0, r.default)(this._value, $);
        return Y;
      }, F._determineQuoteMark = function(E) {
        return E.smart ? this.smartQuoteMark(E) : this.preferredQuoteMark(E);
      }, F.setValue = function(E, k) {
        k === void 0 && (k = {}), this._value = E, this._quoteMark = this._determineQuoteMark(k), this._syncRawValue();
      }, F.smartQuoteMark = function(E) {
        var k = this.value, $ = k.replace(/[^']/g, "").length, Y = k.replace(/[^"]/g, "").length;
        if ($ + Y === 0) {
          var ae = (0, r.default)(k, {
            isIdentifier: !0
          });
          if (ae === k)
            return x.NO_QUOTE;
          var ne = this.preferredQuoteMark(E);
          if (ne === x.NO_QUOTE) {
            var oe = this.quoteMark || E.quoteMark || x.DOUBLE_QUOTE, W = y[oe], ce = (0, r.default)(k, W);
            if (ce.length < ae.length)
              return oe;
          }
          return ne;
        } else return Y === $ ? this.preferredQuoteMark(E) : Y < $ ? x.DOUBLE_QUOTE : x.SINGLE_QUOTE;
      }, F.preferredQuoteMark = function(E) {
        var k = E.preferCurrentQuoteMark ? this.quoteMark : E.quoteMark;
        return k === void 0 && (k = E.preferCurrentQuoteMark ? E.quoteMark : this.quoteMark), k === void 0 && (k = x.DOUBLE_QUOTE), k;
      }, F._syncRawValue = function() {
        var E = (0, r.default)(this._value, y[this.quoteMark]);
        E === this._value ? this.raws && delete this.raws.value : this.raws.value = E;
      }, F._handleEscapes = function(E, k) {
        if (this._constructed) {
          var $ = (0, r.default)(k, {
            isIdentifier: !0
          });
          $ !== k ? this.raws[E] = $ : delete this.raws[E];
        }
      }, F._spacesFor = function(E) {
        var k = {
          before: "",
          after: ""
        }, $ = this.spaces[E] || {}, Y = this.raws.spaces && this.raws.spaces[E] || {};
        return Object.assign(k, $, Y);
      }, F._stringFor = function(E, k, $) {
        k === void 0 && (k = E), $ === void 0 && ($ = I);
        var Y = this._spacesFor(k);
        return $(this.stringifyProperty(E), Y);
      }, F.offsetOf = function(E) {
        var k = 1, $ = this._spacesFor("attribute");
        if (k += $.before.length, E === "namespace" || E === "ns")
          return this.namespace ? k : -1;
        if (E === "attributeNS" || (k += this.namespaceString.length, this.namespace && (k += 1), E === "attribute"))
          return k;
        k += this.stringifyProperty("attribute").length, k += $.after.length;
        var Y = this._spacesFor("operator");
        k += Y.before.length;
        var ae = this.stringifyProperty("operator");
        if (E === "operator")
          return ae ? k : -1;
        k += ae.length, k += Y.after.length;
        var ne = this._spacesFor("value");
        k += ne.before.length;
        var oe = this.stringifyProperty("value");
        if (E === "value")
          return oe ? k : -1;
        k += oe.length, k += ne.after.length;
        var W = this._spacesFor("insensitive");
        return k += W.before.length, E === "insensitive" && this.insensitive ? k : -1;
      }, F.toString = function() {
        var E = this, k = [this.rawSpaceBefore, "["];
        return k.push(this._stringFor("qualifiedAttribute", "attribute")), this.operator && (this.value || this.value === "") && (k.push(this._stringFor("operator")), k.push(this._stringFor("value")), k.push(this._stringFor("insensitiveFlag", "insensitive", function($, Y) {
          return $.length > 0 && !E.quoted && Y.before.length === 0 && !(E.spaces.value && E.spaces.value.after) && (Y.before = " "), I($, Y);
        }))), k.push("]"), k.push(this.rawSpaceAfter), k.join("");
      }, n(x, [{
        key: "quoted",
        get: function() {
          var E = this.quoteMark;
          return E === "'" || E === '"';
        },
        set: function(E) {
          P();
        }
        /**
         * returns a single (`'`) or double (`"`) quote character if the value is quoted.
         * returns `null` if the value is not quoted.
         * returns `undefined` if the quotation state is unknown (this can happen when
         * the attribute is constructed without specifying a quote mark.)
         */
      }, {
        key: "quoteMark",
        get: function() {
          return this._quoteMark;
        },
        set: function(E) {
          if (!this._constructed) {
            this._quoteMark = E;
            return;
          }
          this._quoteMark !== E && (this._quoteMark = E, this._syncRawValue());
        }
      }, {
        key: "qualifiedAttribute",
        get: function() {
          return this.qualifiedName(this.raws.attribute || this.attribute);
        }
      }, {
        key: "insensitiveFlag",
        get: function() {
          return this.insensitive ? "i" : "";
        }
      }, {
        key: "value",
        get: function() {
          return this._value;
        },
        set: function(E) {
          if (this._constructed) {
            var k = c(E), $ = k.deprecatedUsage, Y = k.unescaped, ae = k.quoteMark;
            if ($ && O(), Y === this._value && ae === this._quoteMark)
              return;
            this._value = Y, this._quoteMark = ae, this._syncRawValue();
          } else
            this._value = E;
        }
      }, {
        key: "attribute",
        get: function() {
          return this._attribute;
        },
        set: function(E) {
          this._handleEscapes("attribute", E), this._attribute = E;
        }
      }]), x;
    }(e.default);
    t.default = _, _.NO_QUOTE = null, _.SINGLE_QUOTE = "'", _.DOUBLE_QUOTE = '"';
    var y = (w = {
      "'": {
        quotes: "single",
        wrap: !0
      },
      '"': {
        quotes: "double",
        wrap: !0
      }
    }, w[null] = {
      isIdentifier: !0
    }, w);
    function I(h, x) {
      return "" + x.before + h + x.after;
    }
  }(Mt)), Mt;
}
var ft = { exports: {} }, Cr;
function cn() {
  return Cr || (Cr = 1, function(t, r) {
    r.__esModule = !0, r.default = void 0;
    var T = f(Gt()), e = le();
    function f(n) {
      return n && n.__esModule ? n : { default: n };
    }
    function w(n, o) {
      n.prototype = Object.create(o.prototype), n.prototype.constructor = n, p(n, o);
    }
    function p(n, o) {
      return p = Object.setPrototypeOf || function(u, d) {
        return u.__proto__ = d, u;
      }, p(n, o);
    }
    var v = /* @__PURE__ */ function(n) {
      w(o, n);
      function o(s) {
        var u;
        return u = n.call(this, s) || this, u.type = e.UNIVERSAL, u.value = "*", u;
      }
      return o;
    }(T.default);
    r.default = v, t.exports = r.default;
  }(ft, ft.exports)), ft.exports;
}
var dt = { exports: {} }, Mr;
function fn() {
  return Mr || (Mr = 1, function(t, r) {
    r.__esModule = !0, r.default = void 0;
    var T = f(Oe()), e = le();
    function f(n) {
      return n && n.__esModule ? n : { default: n };
    }
    function w(n, o) {
      n.prototype = Object.create(o.prototype), n.prototype.constructor = n, p(n, o);
    }
    function p(n, o) {
      return p = Object.setPrototypeOf || function(u, d) {
        return u.__proto__ = d, u;
      }, p(n, o);
    }
    var v = /* @__PURE__ */ function(n) {
      w(o, n);
      function o(s) {
        var u;
        return u = n.call(this, s) || this, u.type = e.COMBINATOR, u;
      }
      return o;
    }(T.default);
    r.default = v, t.exports = r.default;
  }(dt, dt.exports)), dt.exports;
}
var pt = { exports: {} }, Nr;
function dn() {
  return Nr || (Nr = 1, function(t, r) {
    r.__esModule = !0, r.default = void 0;
    var T = f(Oe()), e = le();
    function f(n) {
      return n && n.__esModule ? n : { default: n };
    }
    function w(n, o) {
      n.prototype = Object.create(o.prototype), n.prototype.constructor = n, p(n, o);
    }
    function p(n, o) {
      return p = Object.setPrototypeOf || function(u, d) {
        return u.__proto__ = d, u;
      }, p(n, o);
    }
    var v = /* @__PURE__ */ function(n) {
      w(o, n);
      function o(s) {
        var u;
        return u = n.call(this, s) || this, u.type = e.NESTING, u.value = "&", u;
      }
      return o;
    }(T.default);
    r.default = v, t.exports = r.default;
  }(pt, pt.exports)), pt.exports;
}
var ht = { exports: {} }, zr;
function Ri() {
  return zr || (zr = 1, function(t, r) {
    r.__esModule = !0, r.default = T;
    function T(e) {
      return e.sort(function(f, w) {
        return f - w;
      });
    }
    t.exports = r.default;
  }(ht, ht.exports)), ht.exports;
}
var zt = {}, L = {}, Ur;
function pn() {
  if (Ur) return L;
  Ur = 1, L.__esModule = !0, L.combinator = L.word = L.comment = L.str = L.tab = L.newline = L.feed = L.cr = L.backslash = L.bang = L.slash = L.doubleQuote = L.singleQuote = L.space = L.greaterThan = L.pipe = L.equals = L.plus = L.caret = L.tilde = L.dollar = L.closeSquare = L.openSquare = L.closeParenthesis = L.openParenthesis = L.semicolon = L.colon = L.comma = L.at = L.asterisk = L.ampersand = void 0;
  var t = 38;
  L.ampersand = t;
  var r = 42;
  L.asterisk = r;
  var T = 64;
  L.at = T;
  var e = 44;
  L.comma = e;
  var f = 58;
  L.colon = f;
  var w = 59;
  L.semicolon = w;
  var p = 40;
  L.openParenthesis = p;
  var v = 41;
  L.closeParenthesis = v;
  var n = 91;
  L.openSquare = n;
  var o = 93;
  L.closeSquare = o;
  var s = 36;
  L.dollar = s;
  var u = 126;
  L.tilde = u;
  var d = 94;
  L.caret = d;
  var O = 43;
  L.plus = O;
  var P = 61;
  L.equals = P;
  var a = 124;
  L.pipe = a;
  var c = 62;
  L.greaterThan = c;
  var m = 32;
  L.space = m;
  var _ = 39;
  L.singleQuote = _;
  var y = 34;
  L.doubleQuote = y;
  var I = 47;
  L.slash = I;
  var h = 33;
  L.bang = h;
  var x = 92;
  L.backslash = x;
  var F = 13;
  L.cr = F;
  var D = 12;
  L.feed = D;
  var E = 10;
  L.newline = E;
  var k = 9;
  L.tab = k;
  var $ = _;
  L.str = $;
  var Y = -1;
  L.comment = Y;
  var ae = -2;
  L.word = ae;
  var ne = -3;
  return L.combinator = ne, L;
}
var Wr;
function Fi() {
  return Wr || (Wr = 1, function(t) {
    t.__esModule = !0, t.default = P, t.FIELDS = void 0;
    var r = w(pn()), T, e;
    function f() {
      if (typeof WeakMap != "function") return null;
      var a = /* @__PURE__ */ new WeakMap();
      return f = function() {
        return a;
      }, a;
    }
    function w(a) {
      if (a && a.__esModule)
        return a;
      if (a === null || typeof a != "object" && typeof a != "function")
        return { default: a };
      var c = f();
      if (c && c.has(a))
        return c.get(a);
      var m = {}, _ = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var y in a)
        if (Object.prototype.hasOwnProperty.call(a, y)) {
          var I = _ ? Object.getOwnPropertyDescriptor(a, y) : null;
          I && (I.get || I.set) ? Object.defineProperty(m, y, I) : m[y] = a[y];
        }
      return m.default = a, c && c.set(a, m), m;
    }
    for (var p = (T = {}, T[r.tab] = !0, T[r.newline] = !0, T[r.cr] = !0, T[r.feed] = !0, T), v = (e = {}, e[r.space] = !0, e[r.tab] = !0, e[r.newline] = !0, e[r.cr] = !0, e[r.feed] = !0, e[r.ampersand] = !0, e[r.asterisk] = !0, e[r.bang] = !0, e[r.comma] = !0, e[r.colon] = !0, e[r.semicolon] = !0, e[r.openParenthesis] = !0, e[r.closeParenthesis] = !0, e[r.openSquare] = !0, e[r.closeSquare] = !0, e[r.singleQuote] = !0, e[r.doubleQuote] = !0, e[r.plus] = !0, e[r.pipe] = !0, e[r.tilde] = !0, e[r.greaterThan] = !0, e[r.equals] = !0, e[r.dollar] = !0, e[r.caret] = !0, e[r.slash] = !0, e), n = {}, o = "0123456789abcdefABCDEF", s = 0; s < o.length; s++)
      n[o.charCodeAt(s)] = !0;
    function u(a, c) {
      var m = c, _;
      do {
        if (_ = a.charCodeAt(m), v[_])
          return m - 1;
        _ === r.backslash ? m = d(a, m) + 1 : m++;
      } while (m < a.length);
      return m - 1;
    }
    function d(a, c) {
      var m = c, _ = a.charCodeAt(m + 1);
      if (!p[_]) if (n[_]) {
        var y = 0;
        do
          m++, y++, _ = a.charCodeAt(m + 1);
        while (n[_] && y < 6);
        y < 6 && _ === r.space && m++;
      } else
        m++;
      return m;
    }
    var O = {
      TYPE: 0,
      START_LINE: 1,
      START_COL: 2,
      END_LINE: 3,
      END_COL: 4,
      START_POS: 5,
      END_POS: 6
    };
    t.FIELDS = O;
    function P(a) {
      var c = [], m = a.css.valueOf(), _ = m, y = _.length, I = -1, h = 1, x = 0, F = 0, D, E, k, $, Y, ae, ne, oe, W, ce, ve, Ee, me;
      function B(R, q) {
        if (a.safe)
          m += q, W = m.length - 1;
        else
          throw a.error("Unclosed " + R, h, x - I, x);
      }
      for (; x < y; ) {
        switch (D = m.charCodeAt(x), D === r.newline && (I = x, h += 1), D) {
          case r.space:
          case r.tab:
          case r.newline:
          case r.cr:
          case r.feed:
            W = x;
            do
              W += 1, D = m.charCodeAt(W), D === r.newline && (I = W, h += 1);
            while (D === r.space || D === r.newline || D === r.tab || D === r.cr || D === r.feed);
            me = r.space, $ = h, k = W - I - 1, F = W;
            break;
          case r.plus:
          case r.greaterThan:
          case r.tilde:
          case r.pipe:
            W = x;
            do
              W += 1, D = m.charCodeAt(W);
            while (D === r.plus || D === r.greaterThan || D === r.tilde || D === r.pipe);
            me = r.combinator, $ = h, k = x - I, F = W;
            break;
          // Consume these characters as single tokens.
          case r.asterisk:
          case r.ampersand:
          case r.bang:
          case r.comma:
          case r.equals:
          case r.dollar:
          case r.caret:
          case r.openSquare:
          case r.closeSquare:
          case r.colon:
          case r.semicolon:
          case r.openParenthesis:
          case r.closeParenthesis:
            W = x, me = D, $ = h, k = x - I, F = W + 1;
            break;
          case r.singleQuote:
          case r.doubleQuote:
            Ee = D === r.singleQuote ? "'" : '"', W = x;
            do
              for (Y = !1, W = m.indexOf(Ee, W + 1), W === -1 && B("quote", Ee), ae = W; m.charCodeAt(ae - 1) === r.backslash; )
                ae -= 1, Y = !Y;
            while (Y);
            me = r.str, $ = h, k = x - I, F = W + 1;
            break;
          default:
            D === r.slash && m.charCodeAt(x + 1) === r.asterisk ? (W = m.indexOf("*/", x + 2) + 1, W === 0 && B("comment", "*/"), E = m.slice(x, W + 1), oe = E.split(`
`), ne = oe.length - 1, ne > 0 ? (ce = h + ne, ve = W - oe[ne].length) : (ce = h, ve = I), me = r.comment, h = ce, $ = ce, k = W - ve) : D === r.slash ? (W = x, me = D, $ = h, k = x - I, F = W + 1) : (W = u(m, x), me = r.word, $ = h, k = W - I), F = W + 1;
            break;
        }
        c.push([
          me,
          // [0] Token type
          h,
          // [1] Starting line
          x - I,
          // [2] Starting column
          $,
          // [3] Ending line
          k,
          // [4] Ending column
          x,
          // [5] Start position / Source index
          F
          // [6] End position
        ]), ve && (I = ve, ve = null), x = F;
      }
      return c;
    }
  }(zt)), zt;
}
var $r;
function Ci() {
  return $r || ($r = 1, function(t, r) {
    r.__esModule = !0, r.default = void 0;
    var T = F(en()), e = F(tn()), f = F(rn()), w = F(nn()), p = F(an()), v = F(on()), n = F(sn()), o = F(un()), s = x(ln()), u = F(cn()), d = F(fn()), O = F(dn()), P = F(Ri()), a = x(Fi()), c = x(pn()), m = x(le()), _ = gt(), y, I;
    function h() {
      if (typeof WeakMap != "function") return null;
      var B = /* @__PURE__ */ new WeakMap();
      return h = function() {
        return B;
      }, B;
    }
    function x(B) {
      if (B && B.__esModule)
        return B;
      if (B === null || typeof B != "object" && typeof B != "function")
        return { default: B };
      var R = h();
      if (R && R.has(B))
        return R.get(B);
      var q = {}, b = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var A in B)
        if (Object.prototype.hasOwnProperty.call(B, A)) {
          var M = b ? Object.getOwnPropertyDescriptor(B, A) : null;
          M && (M.get || M.set) ? Object.defineProperty(q, A, M) : q[A] = B[A];
        }
      return q.default = B, R && R.set(B, q), q;
    }
    function F(B) {
      return B && B.__esModule ? B : { default: B };
    }
    function D(B, R) {
      for (var q = 0; q < R.length; q++) {
        var b = R[q];
        b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(B, b.key, b);
      }
    }
    function E(B, R, q) {
      return R && D(B.prototype, R), B;
    }
    var k = (y = {}, y[c.space] = !0, y[c.cr] = !0, y[c.feed] = !0, y[c.newline] = !0, y[c.tab] = !0, y), $ = Object.assign({}, k, (I = {}, I[c.comment] = !0, I));
    function Y(B) {
      return {
        line: B[a.FIELDS.START_LINE],
        column: B[a.FIELDS.START_COL]
      };
    }
    function ae(B) {
      return {
        line: B[a.FIELDS.END_LINE],
        column: B[a.FIELDS.END_COL]
      };
    }
    function ne(B, R, q, b) {
      return {
        start: {
          line: B,
          column: R
        },
        end: {
          line: q,
          column: b
        }
      };
    }
    function oe(B) {
      return ne(B[a.FIELDS.START_LINE], B[a.FIELDS.START_COL], B[a.FIELDS.END_LINE], B[a.FIELDS.END_COL]);
    }
    function W(B, R) {
      if (B)
        return ne(B[a.FIELDS.START_LINE], B[a.FIELDS.START_COL], R[a.FIELDS.END_LINE], R[a.FIELDS.END_COL]);
    }
    function ce(B, R) {
      var q = B[R];
      if (typeof q == "string")
        return q.indexOf("\\") !== -1 && ((0, _.ensureObject)(B, "raws"), B[R] = (0, _.unesc)(q), B.raws[R] === void 0 && (B.raws[R] = q)), B;
    }
    function ve(B, R) {
      for (var q = -1, b = []; (q = B.indexOf(R, q + 1)) !== -1; )
        b.push(q);
      return b;
    }
    function Ee() {
      var B = Array.prototype.concat.apply([], arguments);
      return B.filter(function(R, q) {
        return q === B.indexOf(R);
      });
    }
    var me = /* @__PURE__ */ function() {
      function B(q, b) {
        b === void 0 && (b = {}), this.rule = q, this.options = Object.assign({
          lossy: !1,
          safe: !1
        }, b), this.position = 0, this.css = typeof this.rule == "string" ? this.rule : this.rule.selector, this.tokens = (0, a.default)({
          css: this.css,
          error: this._errorGenerator(),
          safe: this.options.safe
        });
        var A = W(this.tokens[0], this.tokens[this.tokens.length - 1]);
        this.root = new T.default({
          source: A
        }), this.root.errorGenerator = this._errorGenerator();
        var M = new e.default({
          source: {
            start: {
              line: 1,
              column: 1
            }
          }
        });
        this.root.append(M), this.current = M, this.loop();
      }
      var R = B.prototype;
      return R._errorGenerator = function() {
        var b = this;
        return function(A, M) {
          return typeof b.rule == "string" ? new Error(A) : b.rule.error(A, M);
        };
      }, R.attribute = function() {
        var b = [], A = this.currToken;
        for (this.position++; this.position < this.tokens.length && this.currToken[a.FIELDS.TYPE] !== c.closeSquare; )
          b.push(this.currToken), this.position++;
        if (this.currToken[a.FIELDS.TYPE] !== c.closeSquare)
          return this.expected("closing square bracket", this.currToken[a.FIELDS.START_POS]);
        var M = b.length, S = {
          source: ne(A[1], A[2], this.currToken[3], this.currToken[4]),
          sourceIndex: A[a.FIELDS.START_POS]
        };
        if (M === 1 && !~[c.word].indexOf(b[0][a.FIELDS.TYPE]))
          return this.expected("attribute", b[0][a.FIELDS.START_POS]);
        for (var z = 0, Q = "", H = "", N = null, K = !1; z < M; ) {
          var ie = b[z], U = this.content(ie), ee = b[z + 1];
          switch (ie[a.FIELDS.TYPE]) {
            case c.space:
              if (K = !0, this.options.lossy)
                break;
              if (N) {
                (0, _.ensureObject)(S, "spaces", N);
                var _e = S.spaces[N].after || "";
                S.spaces[N].after = _e + U;
                var we = (0, _.getProp)(S, "raws", "spaces", N, "after") || null;
                we && (S.raws.spaces[N].after = we + U);
              } else
                Q = Q + U, H = H + U;
              break;
            case c.asterisk:
              if (ee[a.FIELDS.TYPE] === c.equals)
                S.operator = U, N = "operator";
              else if ((!S.namespace || N === "namespace" && !K) && ee) {
                Q && ((0, _.ensureObject)(S, "spaces", "attribute"), S.spaces.attribute.before = Q, Q = ""), H && ((0, _.ensureObject)(S, "raws", "spaces", "attribute"), S.raws.spaces.attribute.before = Q, H = ""), S.namespace = (S.namespace || "") + U;
                var fe = (0, _.getProp)(S, "raws", "namespace") || null;
                fe && (S.raws.namespace += U), N = "namespace";
              }
              K = !1;
              break;
            case c.dollar:
              if (N === "value") {
                var se = (0, _.getProp)(S, "raws", "value");
                S.value += "$", se && (S.raws.value = se + "$");
                break;
              }
            // Falls through
            case c.caret:
              ee[a.FIELDS.TYPE] === c.equals && (S.operator = U, N = "operator"), K = !1;
              break;
            case c.combinator:
              if (U === "~" && ee[a.FIELDS.TYPE] === c.equals && (S.operator = U, N = "operator"), U !== "|") {
                K = !1;
                break;
              }
              ee[a.FIELDS.TYPE] === c.equals ? (S.operator = U, N = "operator") : !S.namespace && !S.attribute && (S.namespace = !0), K = !1;
              break;
            case c.word:
              if (ee && this.content(ee) === "|" && b[z + 2] && b[z + 2][a.FIELDS.TYPE] !== c.equals && // this look-ahead probably fails with comment nodes involved.
              !S.operator && !S.namespace)
                S.namespace = U, N = "namespace";
              else if (!S.attribute || N === "attribute" && !K) {
                Q && ((0, _.ensureObject)(S, "spaces", "attribute"), S.spaces.attribute.before = Q, Q = ""), H && ((0, _.ensureObject)(S, "raws", "spaces", "attribute"), S.raws.spaces.attribute.before = H, H = ""), S.attribute = (S.attribute || "") + U;
                var ue = (0, _.getProp)(S, "raws", "attribute") || null;
                ue && (S.raws.attribute += U), N = "attribute";
              } else if (!S.value && S.value !== "" || N === "value" && !K) {
                var de = (0, _.unesc)(U), pe = (0, _.getProp)(S, "raws", "value") || "", he = S.value || "";
                S.value = he + de, S.quoteMark = null, (de !== U || pe) && ((0, _.ensureObject)(S, "raws"), S.raws.value = (pe || he) + U), N = "value";
              } else {
                var ke = U === "i" || U === "I";
                (S.value || S.value === "") && (S.quoteMark || K) ? (S.insensitive = ke, (!ke || U === "I") && ((0, _.ensureObject)(S, "raws"), S.raws.insensitiveFlag = U), N = "insensitive", Q && ((0, _.ensureObject)(S, "spaces", "insensitive"), S.spaces.insensitive.before = Q, Q = ""), H && ((0, _.ensureObject)(S, "raws", "spaces", "insensitive"), S.raws.spaces.insensitive.before = H, H = "")) : (S.value || S.value === "") && (N = "value", S.value += U, S.raws.value && (S.raws.value += U));
              }
              K = !1;
              break;
            case c.str:
              if (!S.attribute || !S.operator)
                return this.error("Expected an attribute followed by an operator preceding the string.", {
                  index: ie[a.FIELDS.START_POS]
                });
              var Se = (0, s.unescapeValue)(U), vt = Se.unescaped, mt = Se.quoteMark;
              S.value = vt, S.quoteMark = mt, N = "value", (0, _.ensureObject)(S, "raws"), S.raws.value = U, K = !1;
              break;
            case c.equals:
              if (!S.attribute)
                return this.expected("attribute", ie[a.FIELDS.START_POS], U);
              if (S.value)
                return this.error('Unexpected "=" found; an operator was already defined.', {
                  index: ie[a.FIELDS.START_POS]
                });
              S.operator = S.operator ? S.operator + U : U, N = "operator", K = !1;
              break;
            case c.comment:
              if (N)
                if (K || ee && ee[a.FIELDS.TYPE] === c.space || N === "insensitive") {
                  var qe = (0, _.getProp)(S, "spaces", N, "after") || "", Me = (0, _.getProp)(S, "raws", "spaces", N, "after") || qe;
                  (0, _.ensureObject)(S, "raws", "spaces", N), S.raws.spaces[N].after = Me + U;
                } else {
                  var Ne = S[N] || "", ze = (0, _.getProp)(S, "raws", N) || Ne;
                  (0, _.ensureObject)(S, "raws"), S.raws[N] = ze + U;
                }
              else
                H = H + U;
              break;
            default:
              return this.error('Unexpected "' + U + '" found.', {
                index: ie[a.FIELDS.START_POS]
              });
          }
          z++;
        }
        ce(S, "attribute"), ce(S, "namespace"), this.newNode(new s.default(S)), this.position++;
      }, R.parseWhitespaceEquivalentTokens = function(b) {
        b < 0 && (b = this.tokens.length);
        var A = this.position, M = [], S = "", z = void 0;
        do
          if (k[this.currToken[a.FIELDS.TYPE]])
            this.options.lossy || (S += this.content());
          else if (this.currToken[a.FIELDS.TYPE] === c.comment) {
            var Q = {};
            S && (Q.before = S, S = ""), z = new w.default({
              value: this.content(),
              source: oe(this.currToken),
              sourceIndex: this.currToken[a.FIELDS.START_POS],
              spaces: Q
            }), M.push(z);
          }
        while (++this.position < b);
        if (S) {
          if (z)
            z.spaces.after = S;
          else if (!this.options.lossy) {
            var H = this.tokens[A], N = this.tokens[this.position - 1];
            M.push(new n.default({
              value: "",
              source: ne(H[a.FIELDS.START_LINE], H[a.FIELDS.START_COL], N[a.FIELDS.END_LINE], N[a.FIELDS.END_COL]),
              sourceIndex: H[a.FIELDS.START_POS],
              spaces: {
                before: S,
                after: ""
              }
            }));
          }
        }
        return M;
      }, R.convertWhitespaceNodesToSpace = function(b, A) {
        var M = this;
        A === void 0 && (A = !1);
        var S = "", z = "";
        b.forEach(function(H) {
          var N = M.lossySpace(H.spaces.before, A), K = M.lossySpace(H.rawSpaceBefore, A);
          S += N + M.lossySpace(H.spaces.after, A && N.length === 0), z += N + H.value + M.lossySpace(H.rawSpaceAfter, A && K.length === 0);
        }), z === S && (z = void 0);
        var Q = {
          space: S,
          rawSpace: z
        };
        return Q;
      }, R.isNamedCombinator = function(b) {
        return b === void 0 && (b = this.position), this.tokens[b + 0] && this.tokens[b + 0][a.FIELDS.TYPE] === c.slash && this.tokens[b + 1] && this.tokens[b + 1][a.FIELDS.TYPE] === c.word && this.tokens[b + 2] && this.tokens[b + 2][a.FIELDS.TYPE] === c.slash;
      }, R.namedCombinator = function() {
        if (this.isNamedCombinator()) {
          var b = this.content(this.tokens[this.position + 1]), A = (0, _.unesc)(b).toLowerCase(), M = {};
          A !== b && (M.value = "/" + b + "/");
          var S = new d.default({
            value: "/" + A + "/",
            source: ne(this.currToken[a.FIELDS.START_LINE], this.currToken[a.FIELDS.START_COL], this.tokens[this.position + 2][a.FIELDS.END_LINE], this.tokens[this.position + 2][a.FIELDS.END_COL]),
            sourceIndex: this.currToken[a.FIELDS.START_POS],
            raws: M
          });
          return this.position = this.position + 3, S;
        } else
          this.unexpected();
      }, R.combinator = function() {
        var b = this;
        if (this.content() === "|")
          return this.namespace();
        var A = this.locateNextMeaningfulToken(this.position);
        if (A < 0 || this.tokens[A][a.FIELDS.TYPE] === c.comma) {
          var M = this.parseWhitespaceEquivalentTokens(A);
          if (M.length > 0) {
            var S = this.current.last;
            if (S) {
              var z = this.convertWhitespaceNodesToSpace(M), Q = z.space, H = z.rawSpace;
              H !== void 0 && (S.rawSpaceAfter += H), S.spaces.after += Q;
            } else
              M.forEach(function(pe) {
                return b.newNode(pe);
              });
          }
          return;
        }
        var N = this.currToken, K = void 0;
        A > this.position && (K = this.parseWhitespaceEquivalentTokens(A));
        var ie;
        if (this.isNamedCombinator() ? ie = this.namedCombinator() : this.currToken[a.FIELDS.TYPE] === c.combinator ? (ie = new d.default({
          value: this.content(),
          source: oe(this.currToken),
          sourceIndex: this.currToken[a.FIELDS.START_POS]
        }), this.position++) : k[this.currToken[a.FIELDS.TYPE]] || K || this.unexpected(), ie) {
          if (K) {
            var U = this.convertWhitespaceNodesToSpace(K), ee = U.space, _e = U.rawSpace;
            ie.spaces.before = ee, ie.rawSpaceBefore = _e;
          }
        } else {
          var we = this.convertWhitespaceNodesToSpace(K, !0), fe = we.space, se = we.rawSpace;
          se || (se = fe);
          var ue = {}, de = {
            spaces: {}
          };
          fe.endsWith(" ") && se.endsWith(" ") ? (ue.before = fe.slice(0, fe.length - 1), de.spaces.before = se.slice(0, se.length - 1)) : fe.startsWith(" ") && se.startsWith(" ") ? (ue.after = fe.slice(1), de.spaces.after = se.slice(1)) : de.value = se, ie = new d.default({
            value: " ",
            source: W(N, this.tokens[this.position - 1]),
            sourceIndex: N[a.FIELDS.START_POS],
            spaces: ue,
            raws: de
          });
        }
        return this.currToken && this.currToken[a.FIELDS.TYPE] === c.space && (ie.spaces.after = this.optionalSpace(this.content()), this.position++), this.newNode(ie);
      }, R.comma = function() {
        if (this.position === this.tokens.length - 1) {
          this.root.trailingComma = !0, this.position++;
          return;
        }
        this.current._inferEndPosition();
        var b = new e.default({
          source: {
            start: Y(this.tokens[this.position + 1])
          }
        });
        this.current.parent.append(b), this.current = b, this.position++;
      }, R.comment = function() {
        var b = this.currToken;
        this.newNode(new w.default({
          value: this.content(),
          source: oe(b),
          sourceIndex: b[a.FIELDS.START_POS]
        })), this.position++;
      }, R.error = function(b, A) {
        throw this.root.error(b, A);
      }, R.missingBackslash = function() {
        return this.error("Expected a backslash preceding the semicolon.", {
          index: this.currToken[a.FIELDS.START_POS]
        });
      }, R.missingParenthesis = function() {
        return this.expected("opening parenthesis", this.currToken[a.FIELDS.START_POS]);
      }, R.missingSquareBracket = function() {
        return this.expected("opening square bracket", this.currToken[a.FIELDS.START_POS]);
      }, R.unexpected = function() {
        return this.error("Unexpected '" + this.content() + "'. Escaping special characters with \\ may help.", this.currToken[a.FIELDS.START_POS]);
      }, R.namespace = function() {
        var b = this.prevToken && this.content(this.prevToken) || !0;
        if (this.nextToken[a.FIELDS.TYPE] === c.word)
          return this.position++, this.word(b);
        if (this.nextToken[a.FIELDS.TYPE] === c.asterisk)
          return this.position++, this.universal(b);
      }, R.nesting = function() {
        if (this.nextToken) {
          var b = this.content(this.nextToken);
          if (b === "|") {
            this.position++;
            return;
          }
        }
        var A = this.currToken;
        this.newNode(new O.default({
          value: this.content(),
          source: oe(A),
          sourceIndex: A[a.FIELDS.START_POS]
        })), this.position++;
      }, R.parentheses = function() {
        var b = this.current.last, A = 1;
        if (this.position++, b && b.type === m.PSEUDO) {
          var M = new e.default({
            source: {
              start: Y(this.tokens[this.position - 1])
            }
          }), S = this.current;
          for (b.append(M), this.current = M; this.position < this.tokens.length && A; )
            this.currToken[a.FIELDS.TYPE] === c.openParenthesis && A++, this.currToken[a.FIELDS.TYPE] === c.closeParenthesis && A--, A ? this.parse() : (this.current.source.end = ae(this.currToken), this.current.parent.source.end = ae(this.currToken), this.position++);
          this.current = S;
        } else {
          for (var z = this.currToken, Q = "(", H; this.position < this.tokens.length && A; )
            this.currToken[a.FIELDS.TYPE] === c.openParenthesis && A++, this.currToken[a.FIELDS.TYPE] === c.closeParenthesis && A--, H = this.currToken, Q += this.parseParenthesisToken(this.currToken), this.position++;
          b ? b.appendToPropertyAndEscape("value", Q, Q) : this.newNode(new n.default({
            value: Q,
            source: ne(z[a.FIELDS.START_LINE], z[a.FIELDS.START_COL], H[a.FIELDS.END_LINE], H[a.FIELDS.END_COL]),
            sourceIndex: z[a.FIELDS.START_POS]
          }));
        }
        if (A)
          return this.expected("closing parenthesis", this.currToken[a.FIELDS.START_POS]);
      }, R.pseudo = function() {
        for (var b = this, A = "", M = this.currToken; this.currToken && this.currToken[a.FIELDS.TYPE] === c.colon; )
          A += this.content(), this.position++;
        if (!this.currToken)
          return this.expected(["pseudo-class", "pseudo-element"], this.position - 1);
        if (this.currToken[a.FIELDS.TYPE] === c.word)
          this.splitWord(!1, function(S, z) {
            A += S, b.newNode(new o.default({
              value: A,
              source: W(M, b.currToken),
              sourceIndex: M[a.FIELDS.START_POS]
            })), z > 1 && b.nextToken && b.nextToken[a.FIELDS.TYPE] === c.openParenthesis && b.error("Misplaced parenthesis.", {
              index: b.nextToken[a.FIELDS.START_POS]
            });
          });
        else
          return this.expected(["pseudo-class", "pseudo-element"], this.currToken[a.FIELDS.START_POS]);
      }, R.space = function() {
        var b = this.content();
        this.position === 0 || this.prevToken[a.FIELDS.TYPE] === c.comma || this.prevToken[a.FIELDS.TYPE] === c.openParenthesis || this.current.nodes.every(function(A) {
          return A.type === "comment";
        }) ? (this.spaces = this.optionalSpace(b), this.position++) : this.position === this.tokens.length - 1 || this.nextToken[a.FIELDS.TYPE] === c.comma || this.nextToken[a.FIELDS.TYPE] === c.closeParenthesis ? (this.current.last.spaces.after = this.optionalSpace(b), this.position++) : this.combinator();
      }, R.string = function() {
        var b = this.currToken;
        this.newNode(new n.default({
          value: this.content(),
          source: oe(b),
          sourceIndex: b[a.FIELDS.START_POS]
        })), this.position++;
      }, R.universal = function(b) {
        var A = this.nextToken;
        if (A && this.content(A) === "|")
          return this.position++, this.namespace();
        var M = this.currToken;
        this.newNode(new u.default({
          value: this.content(),
          source: oe(M),
          sourceIndex: M[a.FIELDS.START_POS]
        }), b), this.position++;
      }, R.splitWord = function(b, A) {
        for (var M = this, S = this.nextToken, z = this.content(); S && ~[c.dollar, c.caret, c.equals, c.word].indexOf(S[a.FIELDS.TYPE]); ) {
          this.position++;
          var Q = this.content();
          if (z += Q, Q.lastIndexOf("\\") === Q.length - 1) {
            var H = this.nextToken;
            H && H[a.FIELDS.TYPE] === c.space && (z += this.requiredSpace(this.content(H)), this.position++);
          }
          S = this.nextToken;
        }
        var N = ve(z, ".").filter(function(ee) {
          var _e = z[ee - 1] === "\\", we = /^\d+\.\d+%$/.test(z);
          return !_e && !we;
        }), K = ve(z, "#").filter(function(ee) {
          return z[ee - 1] !== "\\";
        }), ie = ve(z, "#{");
        ie.length && (K = K.filter(function(ee) {
          return !~ie.indexOf(ee);
        }));
        var U = (0, P.default)(Ee([0].concat(N, K)));
        U.forEach(function(ee, _e) {
          var we = U[_e + 1] || z.length, fe = z.slice(ee, we);
          if (_e === 0 && A)
            return A.call(M, fe, U.length);
          var se, ue = M.currToken, de = ue[a.FIELDS.START_POS] + U[_e], pe = ne(ue[1], ue[2] + ee, ue[3], ue[2] + (we - 1));
          if (~N.indexOf(ee)) {
            var he = {
              value: fe.slice(1),
              source: pe,
              sourceIndex: de
            };
            se = new f.default(ce(he, "value"));
          } else if (~K.indexOf(ee)) {
            var ke = {
              value: fe.slice(1),
              source: pe,
              sourceIndex: de
            };
            se = new p.default(ce(ke, "value"));
          } else {
            var Se = {
              value: fe,
              source: pe,
              sourceIndex: de
            };
            ce(Se, "value"), se = new v.default(Se);
          }
          M.newNode(se, b), b = null;
        }), this.position++;
      }, R.word = function(b) {
        var A = this.nextToken;
        return A && this.content(A) === "|" ? (this.position++, this.namespace()) : this.splitWord(b);
      }, R.loop = function() {
        for (; this.position < this.tokens.length; )
          this.parse(!0);
        return this.current._inferEndPosition(), this.root;
      }, R.parse = function(b) {
        switch (this.currToken[a.FIELDS.TYPE]) {
          case c.space:
            this.space();
            break;
          case c.comment:
            this.comment();
            break;
          case c.openParenthesis:
            this.parentheses();
            break;
          case c.closeParenthesis:
            b && this.missingParenthesis();
            break;
          case c.openSquare:
            this.attribute();
            break;
          case c.dollar:
          case c.caret:
          case c.equals:
          case c.word:
            this.word();
            break;
          case c.colon:
            this.pseudo();
            break;
          case c.comma:
            this.comma();
            break;
          case c.asterisk:
            this.universal();
            break;
          case c.ampersand:
            this.nesting();
            break;
          case c.slash:
          case c.combinator:
            this.combinator();
            break;
          case c.str:
            this.string();
            break;
          // These cases throw; no break needed.
          case c.closeSquare:
            this.missingSquareBracket();
          case c.semicolon:
            this.missingBackslash();
          default:
            this.unexpected();
        }
      }, R.expected = function(b, A, M) {
        if (Array.isArray(b)) {
          var S = b.pop();
          b = b.join(", ") + " or " + S;
        }
        var z = /^[aeiou]/.test(b[0]) ? "an" : "a";
        return M ? this.error("Expected " + z + " " + b + ', found "' + M + '" instead.', {
          index: A
        }) : this.error("Expected " + z + " " + b + ".", {
          index: A
        });
      }, R.requiredSpace = function(b) {
        return this.options.lossy ? " " : b;
      }, R.optionalSpace = function(b) {
        return this.options.lossy ? "" : b;
      }, R.lossySpace = function(b, A) {
        return this.options.lossy ? A ? " " : "" : b;
      }, R.parseParenthesisToken = function(b) {
        var A = this.content(b);
        return b[a.FIELDS.TYPE] === c.space ? this.requiredSpace(A) : A;
      }, R.newNode = function(b, A) {
        return A && (/^ +$/.test(A) && (this.options.lossy || (this.spaces = (this.spaces || "") + A), A = !0), b.namespace = A, ce(b, "namespace")), this.spaces && (b.spaces.before = this.spaces, this.spaces = ""), this.current.append(b);
      }, R.content = function(b) {
        return b === void 0 && (b = this.currToken), this.css.slice(b[a.FIELDS.START_POS], b[a.FIELDS.END_POS]);
      }, R.locateNextMeaningfulToken = function(b) {
        b === void 0 && (b = this.position + 1);
        for (var A = b; A < this.tokens.length; )
          if ($[this.tokens[A][a.FIELDS.TYPE]]) {
            A++;
            continue;
          } else
            return A;
        return -1;
      }, E(B, [{
        key: "currToken",
        get: function() {
          return this.tokens[this.position];
        }
      }, {
        key: "nextToken",
        get: function() {
          return this.tokens[this.position + 1];
        }
      }, {
        key: "prevToken",
        get: function() {
          return this.tokens[this.position - 1];
        }
      }]), B;
    }();
    r.default = me, t.exports = r.default;
  }(Ve, Ve.exports)), Ve.exports;
}
var Hr;
function Mi() {
  return Hr || (Hr = 1, function(t, r) {
    r.__esModule = !0, r.default = void 0;
    var T = e(Ci());
    function e(w) {
      return w && w.__esModule ? w : { default: w };
    }
    var f = /* @__PURE__ */ function() {
      function w(v, n) {
        this.func = v || function() {
        }, this.funcRes = null, this.options = n;
      }
      var p = w.prototype;
      return p._shouldUpdateSelector = function(n, o) {
        o === void 0 && (o = {});
        var s = Object.assign({}, this.options, o);
        return s.updateSelector === !1 ? !1 : typeof n != "string";
      }, p._isLossy = function(n) {
        n === void 0 && (n = {});
        var o = Object.assign({}, this.options, n);
        return o.lossless === !1;
      }, p._root = function(n, o) {
        o === void 0 && (o = {});
        var s = new T.default(n, this._parseOptions(o));
        return s.root;
      }, p._parseOptions = function(n) {
        return {
          lossy: this._isLossy(n)
        };
      }, p._run = function(n, o) {
        var s = this;
        return o === void 0 && (o = {}), new Promise(function(u, d) {
          try {
            var O = s._root(n, o);
            Promise.resolve(s.func(O)).then(function(P) {
              var a = void 0;
              return s._shouldUpdateSelector(n, o) && (a = O.toString(), n.selector = a), {
                transform: P,
                root: O,
                string: a
              };
            }).then(u, d);
          } catch (P) {
            d(P);
            return;
          }
        });
      }, p._runSync = function(n, o) {
        o === void 0 && (o = {});
        var s = this._root(n, o), u = this.func(s);
        if (u && typeof u.then == "function")
          throw new Error("Selector processor returned a promise to a synchronous call.");
        var d = void 0;
        return o.updateSelector && typeof n != "string" && (d = s.toString(), n.selector = d), {
          transform: u,
          root: s,
          string: d
        };
      }, p.ast = function(n, o) {
        return this._run(n, o).then(function(s) {
          return s.root;
        });
      }, p.astSync = function(n, o) {
        return this._runSync(n, o).root;
      }, p.transform = function(n, o) {
        return this._run(n, o).then(function(s) {
          return s.transform;
        });
      }, p.transformSync = function(n, o) {
        return this._runSync(n, o).transform;
      }, p.process = function(n, o) {
        return this._run(n, o).then(function(s) {
          return s.string || s.root.toString();
        });
      }, p.processSync = function(n, o) {
        var s = this._runSync(n, o);
        return s.string || s.root.toString();
      }, w;
    }();
    r.default = f, t.exports = r.default;
  }(Qe, Qe.exports)), Qe.exports;
}
var Ut = {}, Z = {}, jr;
function Ni() {
  if (jr) return Z;
  jr = 1, Z.__esModule = !0, Z.universal = Z.tag = Z.string = Z.selector = Z.root = Z.pseudo = Z.nesting = Z.id = Z.comment = Z.combinator = Z.className = Z.attribute = void 0;
  var t = d(ln()), r = d(rn()), T = d(fn()), e = d(nn()), f = d(an()), w = d(dn()), p = d(un()), v = d(en()), n = d(tn()), o = d(sn()), s = d(on()), u = d(cn());
  function d(E) {
    return E && E.__esModule ? E : { default: E };
  }
  var O = function(k) {
    return new t.default(k);
  };
  Z.attribute = O;
  var P = function(k) {
    return new r.default(k);
  };
  Z.className = P;
  var a = function(k) {
    return new T.default(k);
  };
  Z.combinator = a;
  var c = function(k) {
    return new e.default(k);
  };
  Z.comment = c;
  var m = function(k) {
    return new f.default(k);
  };
  Z.id = m;
  var _ = function(k) {
    return new w.default(k);
  };
  Z.nesting = _;
  var y = function(k) {
    return new p.default(k);
  };
  Z.pseudo = y;
  var I = function(k) {
    return new v.default(k);
  };
  Z.root = I;
  var h = function(k) {
    return new n.default(k);
  };
  Z.selector = h;
  var x = function(k) {
    return new o.default(k);
  };
  Z.string = x;
  var F = function(k) {
    return new s.default(k);
  };
  Z.tag = F;
  var D = function(k) {
    return new u.default(k);
  };
  return Z.universal = D, Z;
}
var G = {}, Gr;
function zi() {
  if (Gr) return G;
  Gr = 1, G.__esModule = !0, G.isNode = e, G.isPseudoElement = m, G.isPseudoClass = _, G.isContainer = y, G.isNamespace = I, G.isUniversal = G.isTag = G.isString = G.isSelector = G.isRoot = G.isPseudo = G.isNesting = G.isIdentifier = G.isComment = G.isCombinator = G.isClassName = G.isAttribute = void 0;
  var t = le(), r, T = (r = {}, r[t.ATTRIBUTE] = !0, r[t.CLASS] = !0, r[t.COMBINATOR] = !0, r[t.COMMENT] = !0, r[t.ID] = !0, r[t.NESTING] = !0, r[t.PSEUDO] = !0, r[t.ROOT] = !0, r[t.SELECTOR] = !0, r[t.STRING] = !0, r[t.TAG] = !0, r[t.UNIVERSAL] = !0, r);
  function e(h) {
    return typeof h == "object" && T[h.type];
  }
  function f(h, x) {
    return e(x) && x.type === h;
  }
  var w = f.bind(null, t.ATTRIBUTE);
  G.isAttribute = w;
  var p = f.bind(null, t.CLASS);
  G.isClassName = p;
  var v = f.bind(null, t.COMBINATOR);
  G.isCombinator = v;
  var n = f.bind(null, t.COMMENT);
  G.isComment = n;
  var o = f.bind(null, t.ID);
  G.isIdentifier = o;
  var s = f.bind(null, t.NESTING);
  G.isNesting = s;
  var u = f.bind(null, t.PSEUDO);
  G.isPseudo = u;
  var d = f.bind(null, t.ROOT);
  G.isRoot = d;
  var O = f.bind(null, t.SELECTOR);
  G.isSelector = O;
  var P = f.bind(null, t.STRING);
  G.isString = P;
  var a = f.bind(null, t.TAG);
  G.isTag = a;
  var c = f.bind(null, t.UNIVERSAL);
  G.isUniversal = c;
  function m(h) {
    return u(h) && h.value && (h.value.startsWith("::") || h.value.toLowerCase() === ":before" || h.value.toLowerCase() === ":after" || h.value.toLowerCase() === ":first-letter" || h.value.toLowerCase() === ":first-line");
  }
  function _(h) {
    return u(h) && !m(h);
  }
  function y(h) {
    return !!(e(h) && h.walk);
  }
  function I(h) {
    return w(h) || a(h);
  }
  return G;
}
var Yr;
function Ui() {
  return Yr || (Yr = 1, function(t) {
    t.__esModule = !0;
    var r = le();
    Object.keys(r).forEach(function(f) {
      f === "default" || f === "__esModule" || f in t && t[f] === r[f] || (t[f] = r[f]);
    });
    var T = Ni();
    Object.keys(T).forEach(function(f) {
      f === "default" || f === "__esModule" || f in t && t[f] === T[f] || (t[f] = T[f]);
    });
    var e = zi();
    Object.keys(e).forEach(function(f) {
      f === "default" || f === "__esModule" || f in t && t[f] === e[f] || (t[f] = e[f]);
    });
  }(Ut)), Ut;
}
var Qr;
function Wi() {
  return Qr || (Qr = 1, function(t, r) {
    r.__esModule = !0, r.default = void 0;
    var T = p(Mi()), e = w(Ui());
    function f() {
      if (typeof WeakMap != "function") return null;
      var o = /* @__PURE__ */ new WeakMap();
      return f = function() {
        return o;
      }, o;
    }
    function w(o) {
      if (o && o.__esModule)
        return o;
      if (o === null || typeof o != "object" && typeof o != "function")
        return { default: o };
      var s = f();
      if (s && s.has(o))
        return s.get(o);
      var u = {}, d = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var O in o)
        if (Object.prototype.hasOwnProperty.call(o, O)) {
          var P = d ? Object.getOwnPropertyDescriptor(o, O) : null;
          P && (P.get || P.set) ? Object.defineProperty(u, O, P) : u[O] = o[O];
        }
      return u.default = o, s && s.set(o, u), u;
    }
    function p(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var v = function(s) {
      return new T.default(s);
    };
    Object.assign(v, e), delete v.__esModule;
    var n = v;
    r.default = n, t.exports = r.default;
  }(Ye, Ye.exports)), Ye.exports;
}
var Wt, Vr;
function $i() {
  if (Vr) return Wt;
  Vr = 1;
  const t = qi(), r = Wi(), T = r();
  return Wt = {
    isUsableColor(e, f) {
      return t(f) && e !== "gray" && f[600];
    },
    /**
     * @param {string} selector
     */
    commonTrailingPseudos(e) {
      let f = T.astSync(e), w = [];
      for (let [v, n] of f.nodes.entries())
        for (const [o, s] of [...n.nodes].reverse().entries()) {
          if (s.type !== "pseudo" || !s.value.startsWith("::"))
            break;
          w[o] = w[o] || [], w[o][v] = s;
        }
      let p = r.selector();
      for (const v of w) {
        if (!v)
          continue;
        if (new Set(v.map((o) => o.value)).size > 1)
          break;
        v.forEach((o) => o.remove()), p.prepend(v[0]);
      }
      return p.nodes.length ? [p.toString(), f.toString()] : [null, e];
    }
  }, Wt;
}
var $t, Kr;
function Hi() {
  if (Kr) return $t;
  Kr = 1;
  const t = Jr(), r = Si(), T = Oi(), e = xi(), { commonTrailingPseudos: f } = $i(), w = {
    // Reserved for future "magic properties", for example:
    // bulletColor: (color) => ({ 'ul > li::before': { backgroundColor: color } }),
  };
  function p(o, { className: s, modifier: u, prefix: d }) {
    let O = d(`.not-${s}`).slice(1), P = o.startsWith(">") ? `${u === "DEFAULT" ? `.${s}` : `.${s}-${u}`} ` : "", [a, c] = f(o);
    return a ? `:where(${P}${c}):not(:where([class~="${O}"],[class~="${O}"] *))${a}` : `:where(${P}${o}):not(:where([class~="${O}"],[class~="${O}"] *))`;
  }
  function v(o) {
    return typeof o == "object" && o !== null;
  }
  function n(o = {}, { target: s, className: u, modifier: d, prefix: O }) {
    function P(a, c) {
      return s === "legacy" ? [a, c] : Array.isArray(c) ? [a, c] : v(c) ? Object.values(c).some(v) ? [
        p(a, { className: u, modifier: d, prefix: O }),
        c,
        Object.fromEntries(Object.entries(c).map(([_, y]) => P(_, y)))
      ] : [p(a, { className: u, modifier: d, prefix: O }), c] : [a, c];
    }
    return Object.fromEntries(
      Object.entries(
        r(
          {},
          ...Object.keys(o).filter((a) => w[a]).map((a) => w[a](o[a])),
          ...T(o.css || {})
        )
      ).map(([a, c]) => P(a, c))
    );
  }
  return $t = t.withOptions(
    ({ className: o = "prose", target: s = "modern" } = {}) => function({ addVariant: u, addComponents: d, theme: O, prefix: P }) {
      let a = O("typography"), c = { className: o, prefix: P };
      for (let [m, ..._] of [
        ["headings", "h1", "h2", "h3", "h4", "h5", "h6", "th"],
        ["h1"],
        ["h2"],
        ["h3"],
        ["h4"],
        ["h5"],
        ["h6"],
        ["p"],
        ["a"],
        ["blockquote"],
        ["figure"],
        ["figcaption"],
        ["strong"],
        ["em"],
        ["kbd"],
        ["code"],
        ["pre"],
        ["ol"],
        ["ul"],
        ["li"],
        ["table"],
        ["thead"],
        ["tr"],
        ["th"],
        ["td"],
        ["img"],
        ["video"],
        ["hr"],
        ["lead", '[class~="lead"]']
      ]) {
        _ = _.length === 0 ? [m] : _;
        let y = s === "legacy" ? _.map((I) => `& ${I}`) : _.join(", ");
        u(
          `${o}-${m}`,
          s === "legacy" ? y : `& :is(${p(y, c)})`
        );
      }
      d(
        Object.keys(a).map((m) => ({
          [m === "DEFAULT" ? `.${o}` : `.${o}-${m}`]: n(
            a[m],
            {
              target: s,
              className: o,
              modifier: m,
              prefix: P
            }
          )
        }))
      );
    },
    () => ({
      theme: { typography: e }
    })
  ), $t;
}
var ji = Hi();
const Gi = /* @__PURE__ */ Xr(ji);
var Yi = Jr();
const hn = /* @__PURE__ */ Xr(Yi), Qi = hn(({ matchUtilities: t, theme: r }) => {
  const T = r("spacing"), e = r("opacity"), f = r("scale"), w = ["top", "bottom", "left", "right"], p = (v) => Object.fromEntries(
    w.map((n) => [
      `${v}-${n}`,
      (o) => {
        const s = n === "top" || n === "bottom" ? "y" : "x", u = n === "top" || n === "left" ? "-" : "";
        return {
          [`${v === "slide-in-from" ? "--tw-enter-translate" : "--tw-leave-translate"}-${s}`]: `${u}${o}`
        };
      }
    ])
  );
  t(p("slide-in-from"), {
    values: T,
    type: "any"
  }), t(p("slide-out-to"), {
    values: T,
    type: "any"
  }), t(
    {
      "fade-in": (v) => ({ "--tw-enter-opacity": v }),
      "fade-out": (v) => ({ "--tw-leave-opacity": v })
    },
    { values: e }
  ), t(
    {
      "zoom-in": (v) => ({ "--tw-enter-scale": v }),
      "zoom-out": (v) => ({ "--tw-leave-scale": v })
    },
    { values: f }
  );
}), Vi = {
  enter: {
    "0%": {
      opacity: "var(--tw-enter-opacity, 1)",
      transform: `
        translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0)
        scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1))
        rotate(var(--tw-enter-rotate, 0))
      `
    },
    "100%": {
      opacity: "1",
      transform: "none"
    }
  },
  leave: {
    "0%": {
      opacity: "1",
      transform: "none"
    },
    "100%": {
      opacity: "var(--tw-leave-opacity, 1)",
      transform: `
        translate3d(var(--tw-leave-translate-x, 0), var(--tw-leave-translate-y, 0), 0)
        scale3d(var(--tw-leave-scale, 1), var(--tw-leave-scale, 1), var(--tw-leave-scale, 1))
        rotate(var(--tw-leave-rotate, 0))
      `
    }
  },
  shake: {
    "0%": {
      transform: "translateX(0)"
    },
    "25%": {
      transform: "translateX(0.5rem)"
    },
    "75%": {
      transform: "translateX(-0.5rem)"
    },
    "100%": {
      transform: "translateX(0)"
    }
  },
  bounceIn: {
    "from, 20%, 40%, 60%, 80%, to": {
      "animation-timing-function": "cubic-bezier(0.215, 0.61, 0.355, 1)"
    },
    "0%": {
      transform: "scale3d(0.3, 0.3, 0.3)",
      opacity: "0"
    },
    "20%": {
      transform: "scale3d(1.1, 1.1, 1.1)"
    },
    "40%": {
      transform: "scale3d(0.9, 0.9, 0.9)"
    },
    "60%": {
      transform: "scale3d(1.03, 1.03, 1.03)",
      opacity: "1"
    },
    "80%": {
      transform: "scale3d(0.97, 0.97, 0.97)"
    },
    to: {
      transform: "scale3d(1, 1, 1)",
      opacity: "1"
    }
  },
  spinningRing: {
    "0%": {
      transform: "rotate(0deg)"
    },
    "100%": {
      transform: "rotate(360deg)"
    }
  },
  bounce2: {
    "0%, 20%, 50%, 80%, 100%": {
      transform: "translateY(0)"
    },
    "40%": {
      transform: "translateY(-30px)"
    },
    "60%": {
      transform: "translateY(-15px)"
    }
  },
  gelatine: {
    "from, to": {
      transform: "translateY(-38%) scale(1, 1)"
    },
    "25%": {
      transform: "translateY(-38%) scale(0.9, 1.1)"
    },
    "50%": {
      transform: "translateY(-38%) scale(1.1, 0.9)"
    },
    "75%": {
      transform: "translateY(-38%) scale(0.95, 1.05)"
    }
  },
  pulseScale: {
    "0%": {
      transform: "scale(1)"
    },
    "60%": {
      transform: "scale(1.4)"
    },
    "100%": {
      transform: "scale(1)"
    }
  },
  fadeIn: {
    "0%": { opacity: "0" },
    "20%": { opacity: "0" },
    "40%": { opacity: "0.3" },
    "60%": { opacity: "0.5" },
    "80%": { opacity: "0.9" },
    "100%": { opacity: "1" }
  },
  fadeOut: {
    "0%": { opacity: "1" },
    "20%": { opacity: "1" },
    "40%": { opacity: "0.7" },
    "60%": { opacity: "0.5" },
    "80%": { opacity: "0.3" },
    "100%": { opacity: "0" }
  }
}, Ki = {
  in: "enter 150ms ease-out forwards",
  out: "leave 150ms ease-in forwards",
  shake: "shake 0.2s ease-in-out 0s 2",
  bounceIn: "bounceIn 0.225s",
  spinningRing: "spinningRing 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite",
  bounce2: "bounce2 1.3s ease 1.2s",
  gelatine: "gelatine 0.6s ease 0.8s",
  pulseScale: "pulseScale 0.8s",
  fadeIn: "fadeIn 0.5s",
  fadeOut: "fadeOut 0.5s"
}, Xi = {
  minWidth: 20,
  maxWidth: 85.375,
  maxScaleWidth: 120,
  prefix: "text",
  unit: "rem"
}, Ji = hn.withOptions(
  (t) => ({ addUtilities: r, theme: T }) => {
    const { maxWidth: e, minWidth: f, maxScaleWidth: w, prefix: p, unit: v } = {
      ...Xi,
      ...t
    }, n = Object.entries(
      T("fluidType", {})
    ).reduce(
      (o, [
        s,
        [
          u,
          d,
          O = void 0,
          P = {}
        ]
      ]) => {
        const a = {
          ...P,
          "line-height": O
        }, c = d - u, m = e - f, _ = w - f;
        return {
          ...o,
          [`.${p}-${s}`]: {
            "font-size": `${u}${v}`,
            ...a,
            [`@media screen and (min-width: ${f}${v})`]: {
              "font-size": `calc(${u}${v} + ${c} * ((100vw - ${f}${v}) / ${m}))`
            },
            [`@media screen and (min-width: ${w}${v})`]: {
              "font-size": `calc(${u}${v} + ${c} * ${_}${v} / ${m})`
            }
          }
        };
      },
      {}
    );
    r(n);
  },
  () => ({
    theme: {
      fluidType: {}
    }
  })
), Zi = {
  theme: {
    extend: {
      colors: {
        primary: {
          ultraLight: "#F4FAFE",
          light: "#CFE6F3",
          DEFAULT: "#007BC2"
        },
        secondary: {
          DEFAULT: "#CFE6F3"
        },
        black: "#212121",
        gray: {
          nav: "#F7F6F6",
          icon: "#A1A8B2",
          light: {
            DEFAULT: "#D8D8D8",
            1: "#DDDDDD"
          },
          "ultra-light": {
            DEFAULT: "#F1F1F1"
          },
          medium: {
            DEFAULT: "#949494"
          },
          topnav: {
            DEFAULT: "#818790"
          }
        },
        green: {
          DEFAULT: "#35AC5F",
          light: "#CCEAD7"
        },
        red: {
          DEFAULT: "#CD2C2C",
          light: "#CD5151"
        },
        yellow: {
          DEFAULT: "#D99B4F"
        },
        orange: {
          DEFAULT: "#ff963c"
        }
      },
      spacing: {
        "3.75": "0.938rem",
        "4.5": "1.125rem",
        "5.5": "1.375rem",
        "6.25": "1.5625rem",
        "7.5": "1.875rem",
        "8.5": "2.125rem",
        "8.75": "2.1875rem",
        "10.5": "2.625rem",
        "11.5": "2.875rem",
        "12.5": "3.125rem",
        "13.75": "3.4375rem",
        15: "3.75rem",
        "17.5": "4.375rem",
        21: "5.25rem",
        22: "5.5rem",
        22.5: "5.625rem",
        23: "5.75rem",
        25: "6.25rem",
        "27.5": "6.875rem",
        30: "7.5rem",
        35: "8.75rem",
        40: "10rem",
        45: "11.25rem",
        50: "12.5rem",
        68: "17rem",
        69: "17.25rem",
        70: "17.5rem",
        71: "17.75rem",
        80: "20rem"
      },
      boxShadow: {
        "medium-inner": "inset 1px 1px 30px 0 rgb(0 0 0 / 15%)",
        "light-top": "1px 1px 30px 0 rgba(0,0,0,.15)"
      },
      container: {
        center: !0,
        padding: {
          xs: "0.5rem",
          DEFAULT: "1.25rem",
          sm: "2rem",
          md: "3rem",
          lg: "10.5rem",
          xl: "7.5rem"
        },
        screens: {
          xs: "320px",
          sm: "640px",
          md: "960px",
          lg: "1280px",
          xl: "1600px",
          "2xl": "1920px"
        }
      },
      screens: {
        xs: "320px",
        sm: "640px",
        md: "960px",
        lg: "1280px",
        xl: "1600px",
        "2xl": "1920px"
      },
      listStyleImage: {
        "check-green": `url("${_i}")`,
        "check-primary": `url("${bi}")`
      },
      fontSize: {
        nav: ["11px", "17px"],
        hint: ["0.702rem", "1.55"]
      },
      fontFamily: {
        "sans-light": '"adelle-sans", Helvetica, Arial, sans-serif',
        sans: '"adelle-sans", Helvetica, Arial, sans-serif',
        "sans-medium": '"adelle-sans", Helvetica, Arial, sans-serif',
        "sans-semi-bold": '"adelle-sans", Helvetica, Arial, sans-serif',
        "sans-bold": '"adelle-sans", Helvetica, Arial, sans-serif',
        "sans-condensed": '"adelle-sans-condensed", Helvetica, Arial, sans-serif'
      },
      fontWeight: {
        "sans-light": "300",
        sans: "400",
        "sans-medium": "500",
        "sans-semi-bold": "600",
        "sans-bold": "700",
        extrabold: "800"
      },
      zIndex: {
        1e4: "10000",
        10050: "10050",
        10100: "10100",
        "background-image": "-2",
        base: "0",
        chat: "10",
        search: "20",
        "popout-backdrop": "40",
        "mobile-navigation": "30",
        "modal-checkout": "50",
        header: "50",
        popover: "50",
        navigation: "51",
        filter: "51",
        "meta-navigation": "52",
        "modal-checkout-backdrop": "55",
        "header-wrapper": "300",
        "meta-cart": "301",
        popout: "301",
        "side-panel-backdrop": "10000",
        "zoom-modal": "10050",
        "side-panel": "10050",
        "modal-backdrop": "10100",
        modal: "10101"
      },
      fluidType: {
        "2xs": [0.702, 0.878, 1.55],
        xs: [0.79, 0.988, 1.55],
        sm: [0.889, 1.111, 1.55],
        base: [1, 1.25, 1.55],
        md: [1.25, 1.666, 1.3],
        lg: [1.563, 2.221, 1.3],
        xl: [1.953, 2.961, 1.3],
        "2xl": [2.441, 3.947, 1.3],
        "3xl": [3.052, 5.261, 1.3],
        "4xl": [3.433, 5.918, 1.1]
      },
      animation: Ki,
      keyframes: Vi
    }
  },
  plugins: [
    Qi,
    Ji({
      minWidth: 20,
      maxWidth: 85.375,
      maxScaleWidth: 120
    }),
    Gi()
  ]
};
export {
  Zi as default
};
